// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.row {
  /* Prevent Bootstrap clearfix from creating blank box */
  /* Override display: table that might be applied by Bootstrap */
  display: block !important;
  /* When inside .user-pro, use contents display */
}
.row::before, .row::after {
  display: none !important;
  content: none !important;
}
.user-pro .row {
  display: contents !important;
}

body {
  overflow-y: hidden !important;
}

@media (max-width: 767px) {
  body {
    overflow-y: auto !important;
  }
}
.textcolor {
  color: #5ea1d8;
  color: #000;
  position: relative;
  text-decoration: none;
}

.menunav {
  width: 35px;
  height: 5px;
  background-color: white;
  margin: 6px 0;
}

.item {
  margin-top: 20px;
  position: relative;
  /* Preserve original card dimensions - width controlled by grid, height by content */
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
}
.item .rating-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
}

.item .img {
  height: 150px !important;
  background-color: lightgray;
}

p {
  margin: 0px;
}

.zoom {
  cursor: pointer;
  width: 100%;
  height: 70%;
  transition: transform 0.1s;
  /* Animation */
}

.zoom:hover {
  border-radius: 5px;
  transform: scale(1.1);
  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.owl-carousel .owl-nav button.owl-next,
.owl-carousel .owl-nav button.owl-prev,
.owl-carousel button.owl-dot {
  font-size: 55px !important;
}

.owl-theme .owl-nav [class*=owl-] {
  font-size: 55px !important;
  color: black;
}

button span {
  font-size: 55px;
  color: black;
}

.owl-nav {
  display: none;
}

.with-icon {
  display: flex;
  align-items: center;
}

.mat-badge-content {
  background-color: #5ea1d8;
  color: white;
}

.mat-badge-content {
  background: #5ea1d8;
  color: #fff !important;
}

.div1 {
  height: auto;
  min-height: 70px;
  padding-bottom: 10px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  overflow: visible;
  z-index: 1;
}

.div .with-icon[_ngcontent-elp-c267] {
  display: flex;
  align-items: center;
  color: black;
}

.with-icon[_ngcontent-xah-c268] {
  color: black;
}

.item {
  color: black;
}

.mat-mdc-tab-group.mat-primary .mat-ink-bar,
.mat-mdc-tab-nav-bar.mat-primary .mat-ink-bar {
  color: #5ea1d8;
  background-color: #5ea1d8;
}

.notify {
  color: grey;
}

.notify:hover {
  color: #5ea1d8;
}

.notify:active {
  color: #5ea1d8;
}

.notify:focus {
  color: #5ea1d8;
}

.mat-tab-body-content {
  height: unset !important;
}
.mat-tab-body-content .item {
  margin-top: 5px;
}

/*new added apart from user view profile*/
.gridgroup-wrap {
  max-width: 100%;
  flex: 1;
  height: calc(100vh - 56px); /* full viewport minus fixed header */
  overflow-y: auto; /* scroll only right content; keep tabs sticky */
  padding-left: 0 !important; /* remove unintended left padding */
  /* Keep Angular Material tab header fixed while content scrolls */
}
.gridgroup-wrap .mat-mdc-tab-header,
.gridgroup-wrap .mat-mdc-tab-group .mat-mdc-tab-header {
  position: sticky;
  top: 0; /* sticky relative to the scrollable right pane */
  z-index: 7;
  background: #ffffff;
}
.gridgroup-wrap br {
  display: none;
}
.gridgroup-wrap .mat-grid-list {
  display: none;
}
.gridgroup-wrap .textcolor {
  padding: 5px 10px;
  background: #fff;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  font-family: "Raleway";
  font-weight: 500;
  cursor: pointer;
  font-size: 17px;
  color: #000;
}
.gridgroup-wrap .mat-tab-label {
  font-family: "Raleway";
  font-weight: 500;
  cursor: pointer;
  font-size: 17px;
  color: #5ea1d8;
}

/*new added apart from user view profile end*/
.example-container {
  display: flex;
  min-width: auto !important;
  padding: 0; /* header offset handled globally */
  height: calc(100vh - 56px); /* ensure columns share same viewport height */
  align-items: stretch; /* make children equal height */
  position: relative;
}
.example-container .disnone {
  display: none;
}
.example-container .userico {
  width: 100%;
  position: sticky;
  top: 56px; /* stay under fixed header */
  height: calc(100vh - 56px);
  margin: 0px !important;
  box-shadow: none !important;
  overflow: hidden;
  background: #fff;
  overflow-y: auto;
}
.example-container .userico::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.example-container .userico::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.example-container .userico::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}
.example-container .user-pro {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  padding: 0;
  width: 100%;
  /* Desktop: align spacing to search page */
  /* Thumbnail wrapper matching search page */
  /* Remove any inner margins from direct children */
  /* Search-like thumbnail styling - ensure consistent 16:9 aspect ratio */
  /* Video info section matching search page */
  /* Restructure to video-info style */
  /* Price badge matching search page - positioned on thumbnail */
  /* Unique ID styling */
}
.example-container .user-pro .row {
  display: contents; /* Let grid handle layout */
  /* Override Bootstrap clearfix that creates blank box */
}
.example-container .user-pro .row::before, .example-container .user-pro .row::after {
  display: none !important;
  content: none !important;
}
.example-container .user-pro .item {
  background-color: transparent;
  border-radius: 12px;
  overflow: visible;
  transition: transform 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  width: 100% !important;
  border: none !important;
  box-shadow: none !important;
  /* Preserve original card dimensions - maintain existing size */
  min-height: auto !important;
  height: auto !important;
}
@media (min-width: 992px) {
  .example-container .user-pro {
    padding-bottom: 24px; /* Add space before blog listing and ensure tab indicator is visible */
  }
  .example-container .user-pro .row {
    margin-top: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    display: contents !important; /* Ensure contents display on desktop */
    /* Override Bootstrap clearfix that creates blank box */
  }
  .example-container .user-pro .row::before, .example-container .user-pro .row::after {
    display: none !important;
    content: none !important;
  }
  .example-container .user-pro .item {
    margin: 0 !important;
    padding: 0 !important;
  }
  .example-container .user-pro .video-thumbnail {
    margin-bottom: 12px;
  }
}
.example-container .user-pro .item:hover {
  transform: translateY(-2px);
}
.example-container .user-pro .item > div:first-child {
  position: relative;
  width: 100% !important;
  aspect-ratio: 16/9 !important;
  background-color: #f5f5f5;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 12px;
  cursor: pointer;
}
.example-container .user-pro .item > div {
  margin: 0px 0px 5px 0px !important;
  padding: 0 !important;
}
.example-container .user-pro .item .img-display,
.example-container .user-pro .item .video-display {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  background-color: #f5f5f5;
  border-radius: 12px;
  display: block;
  padding: 0 !important;
  margin: 0 !important;
}
.example-container .user-pro .item > div:last-child {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0;
  flex: 1 0 auto;
  position: relative;
  /* Title first */
  /* Unique ID second */
  /* Avatar and username third */
}
.example-container .user-pro .item > div:last-child p.lf13 {
  order: 1;
  margin: 0;
}
.example-container .user-pro .item > div:last-child p:not(.lf13):not(.with-icon p) {
  order: 2;
  margin: 0;
}
.example-container .user-pro .item > div:last-child .with-icon {
  order: 3;
  margin: 0;
}
.example-container .user-pro .item > div:last-child .with-icon {
  display: flex;
  align-items: center;
  gap: 10px;
}
.example-container .user-pro .item p.lf13 {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #000000;
  cursor: pointer;
}
.example-container .user-pro .item .with-icon {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
}
.example-container .user-pro .item .with-icon img {
  width: 36px !important;
  height: 36px !important;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.example-container .user-pro .item .with-icon p {
  font-size: 13px;
  color: #606060;
  margin: 0;
  line-height: 1.2;
  cursor: pointer;
}
.example-container .user-pro .item > div:first-child {
  position: relative;
}
.example-container .user-pro .item .priceIcon-p {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  background-color: rgba(33, 36, 39, 0.5);
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 6px;
  -webkit-backdrop-filter: saturate(120%);
          backdrop-filter: saturate(120%);
  margin: 0;
  border: none;
}
.example-container .user-pro .item .priceIcon-p mat-label {
  color: #ffffff !important;
}
.example-container .user-pro .item p:not(.lf13):not(.with-icon p) {
  font-size: 12px;
  color: #606060;
  margin: 0;
  line-height: 1.2;
}

/* Desktop: show profile (left panel) at the top, like mobile/tablet */
@media (min-width: 993px) {
  .example-container {
    display: block !important; /* stack children */
    flex-direction: column !important;
    height: auto !important; /* allow natural stacking height */
    align-items: initial !important;
  }
  .example-container .userico {
    position: relative !important;
    top: 0 !important;
    height: auto !important;
    overflow: initial !important;
    width: 100% !important;
  }
  .gridgroup-wrap {
    height: auto !important;
    overflow: visible !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 24px !important; /* Match search page padding */
  }
  .vp-wrapper {
    border-right: 0 !important;
    border-bottom: 2px solid lightgrey !important;
    height: auto !important; /* shrink to content to avoid empty right area */
    padding-left: 0 !important; /* override inline left padding */
    margin: 0 auto; /* center the profile block */
    padding-right: 24px;
  }
  /* Center inner content and constrain width */
  .vp-wrapper .vp-userdetails,
  .vp-wrapper .mat-mdc-card-header {
    max-width: 1200px;
    margin: 0 auto;
  }
  /* Remove any unintended horizontal gaps */
  .userico {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  /* Make profile text/buttons readable over white background */
  .vp-wrapper .vp-userdetails {
    color: #212427 !important;
  }
  .vp-wrapper .vp-userdetails span {
    color: #212427 !important;
  }
  .vp-wrapper .vp-userdetails a {
    color: #5ea1d8 !important;
  }
  .vp-wrapper .vp-userdetails .button-wrap a {
    display: inline-block !important;
    width: auto !important;
    padding: 8px 14px !important;
    margin-right: 12px;
  }
}
.vp-wrapper {
  display: flex;
  width: 100%;
  font-family: "Raleway";
  flex-direction: column;
  padding: 0.5rem 3rem;
  border-radius: 0px;
  box-shadow: none;
  margin-left: 0px;
  height: 100%;
  border-right: 2px solid lightgrey !important;
  z-index: 3;
  background: transparent;
}
.vp-wrapper .material-icons {
  font-size: 200px !important;
}
.vp-wrapper .vp-userdetails {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  padding: 20px 0px 0px;
  height: 100%;
  color: #212427;
}
.vp-wrapper .vp-userdetails .vp-usertext {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.vp-wrapper .vp-userdetails .button-wrap p,
.vp-wrapper .vp-userdetails .button-wrap a {
  display: block;
  color: #fff !important;
  padding: 10px;
  background: #5ea1d8 !important;
  text-align: center;
  font-weight: 500;
  border-radius: 5px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 33px;
}
.vp-wrapper .vp-userdetails span {
  word-break: break-all;
  margin-bottom: 10px;
}
.vp-wrapper .vp-userdetails a {
  margin-bottom: 10px;
  cursor: pointer;
  color: #5ea1d8 !important;
}
.vp-wrapper .vp-userdetails br {
  display: none;
}
.vp-wrapper .mat-mdc-card-header {
  display: flex;
  max-width: 300px;
  width: 100%;
  text-align: center;
  margin: 0px auto;
}
.vp-wrapper .mat-mdc-card-header .mat-mdc-card-avatar {
  width: auto;
  height: auto;
  width: 100%;
}
.vp-wrapper .mat-mdc-card-header .mat-mdc-card-avatar img {
  width: 200px;
  height: 200px;
  object-fit: cover;
}

/* Profile hero overlay layout */
.profile-hero {
  position: relative;
  display: block;
}

.profile-hero .profile-avatar {
  z-index: 1;
}

.profile-hero .profile-overlay {
  position: static;
}

@media (min-width: 993px) {
  .profile-hero {
    min-height: 140px;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .profile-hero .profile-avatar {
    position: relative;
    flex: 0 0 auto;
  }
  .profile-hero .profile-overlay {
    position: static;
    flex: 1 1 auto;
    min-width: 0;
  }
  .profile-hero .example-header-image img,
  .profile-hero .example-header-image .material-icons {
    width: 120px !important;
    height: 120px !important;
  }
}
/* Banner */
.profile-banner {
  width: 100%;
  height: 180px;
  background: linear-gradient(90deg, #f7f7f7, #eaeaea);
}

/* Header row: name + actions */
.profile-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.plan-label-chip {
  border: 1px solid rgba(94, 161, 216, 0.35);
  background: rgba(94, 161, 216, 0.12);
  color: #1d4f7a;
  border-radius: 999px;
  padding: 0.2rem 0.7rem;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  cursor: pointer;
  line-height: 1.4;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.plan-label-chip:hover {
  background: rgba(94, 161, 216, 0.2);
  border-color: #5ea1d8;
}

.profile-stats {
  display: flex;
  gap: 24px;
  margin-top: 20px;
  flex-wrap: wrap;
}
.profile-stats .stat {
  display: flex;
  flex-direction: column;
  min-width: 100px;
}
.profile-stats .stat .stat-number {
  font-size: 18px;
  font-weight: 700;
  color: #212427 !important;
}
.profile-stats .stat .stat-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #606060 !important;
}

.profile-stat-bar {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  padding: 16px 0;
}
.profile-stat-bar .profile-stat-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.profile-stat-bar .profile-stat-item .label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #606060 !important;
}
.profile-stat-bar .profile-stat-item .value {
  font-size: 18px;
  font-weight: 700;
  color: #212427 !important;
}

.profile-header-row .actions-row a {
  display: inline-block;
  padding: 8px 14px;
  border-radius: 6px;
}

/* Mobile: Ensure buttons are well aligned */
@media (max-width: 992px) {
  .profile-header-row .actions-row {
    align-items: center;
  }
  .profile-header-row .actions-row a {
    margin-top: 0 !important;
    vertical-align: middle;
    display: inline-flex;
    align-items: center;
  }
}
/* Mobile and tablet: allow wrapping for long usernames */
@media (max-width: 992px) {
  .profile-header-row {
    flex-wrap: wrap;
    align-items: flex-start;
  }
  .tagparent {
    flex: 1 1 100%;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }
  .tagparent .profile-title-row {
    flex: 1 1 auto;
    min-width: 0;
  }
  .tagparent .profile-title-row h2 {
    word-break: break-word;
    overflow-wrap: break-word;
  }
  .tagparent > span {
    flex-shrink: 0;
    margin-left: 0 !important;
  }
  .actions-row {
    flex: 1 1 100%;
    margin-top: 8px;
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;
  }
  .actions-row a {
    margin-top: 0 !important;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
  }
}
/* Tabs styling */
.tabs-container .mat-tab-label {
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mat-mdc-tab-group.mat-primary .mat-ink-bar,
.mat-mdc-tab-nav-bar.mat-primary .mat-ink-bar {
  height: 2px;
}

h2 {
  font-size: 26px !important;
}

h3 {
  font-size: 20px !important;
}

.flowdraft-wrap {
  padding: 0rem 0rem 2rem;
  overflow-y: scroll;
  margin-left: 10px;
}

.draft-flow-card {
  position: relative;
}

.content-status-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 4px 0 6px;
}

.content-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
  background: #f2f4f7;
  color: #344054;
}
.content-status-badge[data-state=in-review] {
  background: #fff4e5;
  color: #b54708;
}
.content-status-badge[data-state=rejected] {
  background: #fdecec;
  color: #b42318;
}
.content-status-badge[data-state=approved] {
  background: #e8f7ee;
  color: #067647;
}
.content-status-badge[data-state=pack] {
  background: #eef4ff;
  color: #3538cd;
}

.draft-flow-delete-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 12;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  padding: 0;
}
.draft-flow-delete-btn:hover {
  background: rgba(198, 40, 40, 0.9);
  transform: scale(1.05);
}
.draft-flow-delete-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

/*followerd added right*/
.addrgt .mat-mdc-grid-tile:first-child {
  display: none;
}
.addrgt .mat-mdc-grid-tile {
  display: block;
  position: absolute;
  overflow: hidden;
  max-width: 100% !important;
  width: 100% !important;
  left: 0px !important;
}
.addrgt .textcolor {
  padding: 5px 10px;
  background: #fff;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  font-family: "Raleway";
  font-weight: 500;
  cursor: pointer;
  font-size: 17px;
  color: #000;
  border-radius: 5px;
}
.addrgt .mat-mdc-figure div {
  display: flex !important;
}

@media only screen and (max-width: 1200px) and (min-width: 768px) {
  .example-container {
    display: flex;
    min-width: auto !important;
    flex-direction: column;
  }
  .example-container .disnone {
    display: none;
  }
  .example-container .userico {
    max-width: 100%;
    position: relative;
    top: 0px;
    height: auto;
    margin: 0px !important;
    box-shadow: none !important;
    overflow: initial;
  }
  .example-container .user-pro {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }
  .example-container .user-pro .row {
    display: contents;
  }
  .example-container .user-pro .item {
    width: 100% !important;
    margin: 0 !important;
  }
  .example-container .user-pro .with-icon.ng-star-inserted {
    width: 100% !important;
  }
  .vp-wrapper {
    display: flex;
    width: 100%;
    font-family: "Raleway";
    flex-direction: row;
    padding: 2rem 3rem !important;
    border-radius: 0px;
    box-shadow: none;
    margin-left: 0px;
    height: 100%;
    border-right: 0px solid #5ea1d8 !important;
  }
  .vp-wrapper .vp-userdetails {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    padding: 20px 0px 0px 20px;
    height: 100%;
  }
  .vp-wrapper .vp-userdetails .vp-usertext {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .vp-wrapper .vp-userdetails .button-wrap p,
  .vp-wrapper .vp-userdetails .button-wrap a {
    display: inline-block;
    color: #fff !important;
    padding: 10px 20px;
    height: auto;
  }
  .vp-wrapper .vp-userdetails span {
    word-break: break-all;
    margin-bottom: 10px;
  }
  .vp-wrapper .vp-userdetails br {
    display: none;
  }
  .vp-wrapper .mat-mdc-card-header {
    display: flex;
    max-width: 200px;
    width: 100%;
    text-align: center;
  }
  .vp-wrapper .mat-mdc-card-header .mat-mdc-card-avatar {
    width: auto;
    height: auto;
    width: 100%;
  }
  .vp-wrapper .mat-mdc-card-header .mat-mdc-card-avatar img {
    width: 200px;
    height: 200px;
    object-fit: cover;
  }
}
@media (max-width: 992px) {
  .vp-wrapper {
    padding: 2rem 15px !important;
    margin-left: 0px;
    flex-wrap: wrap;
  }
  .flowdraft-wrap {
    padding: 0rem 0px 2rem;
  }
  .flowdraft-wrap .mat-mdc-tab-body-wrapper {
    padding: 0px 15px;
  }
  .example-container {
    height: inherit !important;
  }
  .example-container .user-pro {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 0px 5px 0px 0px !important;
    margin: 0;
  }
  .example-container .user-pro .item {
    width: 100% !important;
    margin: 0 !important;
  }
}
@media (max-width: 768px) {
  .example-container .user-pro {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px; /* Match search page mobile gap */
    padding: 0 !important; /* Remove padding to match search */
  }
}
@media (max-width: 480px) {
  .example-container .user-pro {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
@media (max-width: 767px) {
  mat-sidenav-content.example-container {
    overflow: visible !important;
    height: auto !important;
    min-height: 100vh !important;
  }
  .example-container {
    display: flex;
    min-width: auto !important;
    flex-direction: column;
    height: auto !important;
    overflow: visible !important;
  }
  .example-container .disnone {
    display: none;
  }
  .example-container .userico {
    max-width: 100%;
    position: relative;
    top: 0px;
    height: auto;
    margin: 0px !important;
    box-shadow: none !important;
    overflow: visible;
  }
  /* Remove padding-bottom for mat-mdc-card-content:last-child on mobile for userprofile */
  mat-mdc-card-content:last-child {
    padding-bottom: 0 !important;
  }
  .vp-wrapper {
    display: flex;
    width: 100%;
    font-family: "Raleway";
    flex-direction: column;
    padding: 0.5rem 15px !important;
    padding-left: 15px !important;
    border-radius: 0px;
    box-shadow: none;
    margin-left: 0px;
    height: auto;
    border-right: 0px solid #5ea1d8 !important;
  }
  .vp-wrapper .profile-hero {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .vp-wrapper .profile-avatar {
    display: flex !important;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
  }
  .vp-wrapper .example-header-image {
    display: block !important;
    visibility: visible !important;
    width: auto;
    height: auto;
  }
  .vp-wrapper .example-header-image img {
    display: block !important;
    visibility: visible !important;
    border-radius: 50%;
  }
  .vp-wrapper .example-header-image .material-icons {
    display: block !important;
    visibility: visible !important;
    font-size: 120px !important;
  }
  .vp-wrapper .vp-userdetails {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    padding: 20px 0px 0px 0px;
    height: auto;
    width: 100%;
  }
  .vp-wrapper .vp-userdetails .vp-usertext {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .vp-wrapper .vp-userdetails .button-wrap p,
  .vp-wrapper .vp-userdetails .button-wrap a {
    display: inline-block;
    color: #fff !important;
    padding: 10px 20px;
    height: auto;
  }
  .vp-wrapper .vp-userdetails span {
    word-break: break-all;
    margin-bottom: 10px;
  }
  .vp-wrapper .vp-userdetails br {
    display: none;
  }
  .vp-wrapper .mat-mdc-card-header {
    display: flex !important;
    max-width: 100%;
    width: 100%;
    justify-content: center;
    margin: 0 auto;
    text-align: center;
  }
  .vp-wrapper .mat-mdc-card-header .mat-mdc-card-avatar {
    width: auto !important;
    height: auto !important;
    max-width: 200px;
    display: flex !important;
    justify-content: center;
  }
  .vp-wrapper .mat-mdc-card-header .mat-mdc-card-avatar img {
    width: 120px !important;
    height: 120px !important;
    object-fit: cover;
    display: block !important;
    visibility: visible !important;
  }
  .gridgroup-wrap {
    height: auto !important;
    overflow: visible !important;
    max-height: none !important;
    /* Mobile: let media run edge-to-edge like search page (no horizontal padding) */
    padding: 0 0 60px !important; /* only space above bottom nav */
  }
  .example-container {
    height: auto !important;
    overflow: visible !important;
  }
  .example-container .user-pro {
    padding: 0 !important; /* Match search page - no padding */
    margin: 0;
    width: 100%;
    /* Thumbnail wrapper - full width, square edges */
    /* Images and videos - full width, square edges */
    /* Card content - match search page (no padding on card content) */
  }
  .example-container .user-pro .item {
    width: 100% !important;
    margin: 0 !important;
    border-radius: 0 !important;
    padding: 0;
  }
  .example-container .user-pro .item > div:first-child {
    border-radius: 0 !important;
    margin-bottom: 12px; /* Match search page */
    width: 100%;
  }
  .example-container .user-pro .item .img-display,
  .example-container .user-pro .item .video-display {
    border-radius: 0 !important;
    width: 100% !important;
  }
  .example-container .user-pro .item > div:last-child {
    padding: 0; /* Match search page - no padding on card content */
    gap: 4px;
  }
  .example-container .user-pro .item > div:last-child p.lf13 {
    margin: 0 !important;
    line-height: 1.3;
  }
  .example-container .user-pro .item > div:last-child p:not(.lf13):not(.with-icon p) {
    margin: 0 !important;
    line-height: 1.2;
  }
  .example-container .user-pro .item > div:last-child .with-icon {
    margin: 0 !important;
  }
  .example-container .user-pro .item > div:last-child .with-icon p {
    line-height: 1.2;
  }
  .example-container .user-pro .row {
    padding-bottom: 0;
    margin: 0;
  }
}
@media (max-width: 480px) {
  .example-container .user-pro {
    grid-template-columns: 1fr;
    gap: 16px; /* Match search page mobile gap */
    padding: 0 !important; /* Match search page - no padding */
  }
}
@media (max-width: 460px) {
  .vp-wrapper {
    flex-direction: column;
  }
  .vp-wrapper .vp-userdetails {
    padding: 20px 0px 0px;
  }
  .vp-wrapper .mat-mdc-card-header {
    max-width: 100%;
  }
  .example-container {
    height: inherit !important;
  }
  .example-container .user-pro {
    grid-template-columns: 1fr;
    gap: 0;
    padding: 0px 0px 0px 0px !important;
    margin: 0;
    width: 100%;
    /* Thumbnail wrapper - full width, square edges */
    /* Images and videos - full width, square edges */
    /* Reduce spacing in card content on mobile */
  }
  .example-container .user-pro .item {
    width: 100% !important;
    margin: 0 !important;
    border-radius: 0 !important;
    padding: 0;
  }
  .example-container .user-pro .item > div:first-child {
    border-radius: 0 !important;
    margin-bottom: 12px !important;
    width: 100%;
  }
  .example-container .user-pro .item .img-display,
  .example-container .user-pro .item .video-display {
    border-radius: 0 !important;
    width: 100% !important;
  }
  .example-container .user-pro .item > div:last-child {
    padding: 0 12px 8px 12px;
    gap: 4px;
  }
  .example-container .user-pro .item > div:last-child p.lf13 {
    margin: 0 !important;
    line-height: 1.3;
  }
  .example-container .user-pro .item > div:last-child p:not(.lf13):not(.with-icon p) {
    margin: 0 !important;
    line-height: 1.2;
  }
  .example-container .user-pro .item > div:last-child .with-icon {
    margin: 0 !important;
  }
  .example-container .user-pro .item > div:last-child .with-icon p {
    line-height: 1.2;
  }
  .gridgroup-wrap .mat-badge {
    font-size: 10px;
  }
}
/*flow by id has 6 item in dt and user flow has 5*/
.user-pro .ng-star-inserted:nth-child(6n+6) .item {
  margin-right: 20px;
}

/* Cards in tabs should have margin-top: 5px */
.tabs-container .user-pro .item,
.mat-tab-body-content .user-pro .item,
.scroll.user-pro .item {
  margin-top: 5px !important;
}

.vp-wrapper {
  /* Mobile/tablet: ensure tagparent wraps properly */
}
.vp-wrapper .tagparent {
  display: flex;
  align-items: center;
}
.vp-wrapper .tagparent h2 {
  flex: 1;
}
.vp-wrapper .tagparent span {
  color: rgba(0, 0, 0, 0.54) !important;
  font-size: 35px !important;
}
.vp-wrapper .tagparent span .material-icons {
  font-size: 35px !important;
}
@media (max-width: 992px) {
  .vp-wrapper .tagparent {
    flex-wrap: wrap;
  }
  .vp-wrapper .tagparent .profile-title-row {
    flex: 1 1 auto;
    min-width: 0;
  }
  .vp-wrapper .tagparent > span {
    flex-shrink: 0;
  }
}

.tagparent > div {
  flex: 1;
}

.vp-wrapper .material-icons {
  font-size: 24px;
}

.flowbycat {
  position: sticky;
  top: 0px;
}

@media only screen and (max-width: 1024px) and (min-width: 993px) {
  .vp-wrapper {
    flex-direction: column;
    padding: 2rem 1rem !important;
  }
  .vp-wrapper .vp-userdetails {
    padding: 20px 0px 0px 0px !important;
  }
}
.scroll .item .uni-wrapper .bundleIcon {
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
  max-width: 25px !important;
  height: 25px !important;
}
.scroll .item .uni-wrapper .bundleIcon img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

/* Bundle icon inside video-thumbnail (new card structure) */
.scroll .item .video-thumbnail .bundleIcon {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
  max-width: 25px !important;
}
.scroll .item .video-thumbnail .bundleIcon img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

.uni-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
}
.uni-wrapper P {
  flex: 1;
}

.tabs-container {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  /* Prevent tabs from wrapping onto multiple lines */
  position: sticky;
  top: 0; /* header offset handled by outer container */
  z-index: 5;
  background: #ffffff;
}
.tabs-container .item {
  margin-top: 5px;
}

/* Mobile search header — aligned with app header mobile search (search-box / app-search-input) */
.mobile-search-header {
  position: sticky;
  top: 0;
  z-index: 8;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
}
.mobile-search-header .profile-search-toggle {
  flex-shrink: 0;
  border: none;
  background: transparent;
  padding: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #606060;
  border-radius: 50%;
  transition: color 0.2s, background-color 0.2s;
}
.mobile-search-header .profile-search-toggle:hover {
  color: #000000;
  background-color: transparent;
}
.mobile-search-header .profile-search-toggle mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.mobile-search-header .profile-mobile-search-box {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  position: relative;
  overflow: visible;
}
.mobile-search-header .profile-mobile-search-box .mobile-search-field {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: visible;
  gap: 4px;
  height: 100%;
}
.mobile-search-header .profile-mobile-search-box .mobile-search-field .app-search-input {
  flex: 1;
  min-width: 120px;
  padding: 8px 16px;
  padding-right: 8px;
  border: 1px solid #d0d0d0;
  border-radius: 24px;
  font-size: 16px;
  background: #ffffff;
  height: 32px;
  box-sizing: border-box;
  color: #000000;
  outline: none;
}
.mobile-search-header .profile-mobile-search-box .mobile-search-field .app-search-input::placeholder {
  color: #666666;
}
.mobile-search-header .profile-mobile-search-box .mobile-search-field:focus-within .app-search-input {
  border-color: #1a73e8;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.mobile-search-header .profile-mobile-search-box .mobile-search-field .cancel-icon-button,
.mobile-search-header .profile-mobile-search-box .mobile-search-field .search-icon-button {
  flex-shrink: 0;
  padding: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #606060;
  border-radius: 50%;
  transition: color 0.2s, background-color 0.2s;
}
.mobile-search-header .profile-mobile-search-box .mobile-search-field .cancel-icon-button:hover,
.mobile-search-header .profile-mobile-search-box .mobile-search-field .search-icon-button:hover {
  color: #000000;
  background-color: transparent;
}
.mobile-search-header .profile-mobile-search-box .mobile-search-field .cancel-icon-button mat-icon,
.mobile-search-header .profile-mobile-search-box .mobile-search-field .search-icon-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.foot-ico {
  padding: 8px 0 10px 0;
}
.foot-ico ul {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
}
.foot-ico ul li {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 4px;
}
.foot-ico ul li span {
  text-align: center;
  display: block;
  width: 100%;
}
.foot-ico ul li .icon-text {
  text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
  font-size: 12px;
  color: gray;
  display: block;
  text-align: center;
  font-family: "Raleway" !important;
  margin-top: 2px;
  line-height: 1.2;
}

a.textcolor:hover {
  text-decoration: underline;
}

.featured-section {
  max-width: 100%;
  overflow: hidden;
}

.section-title {
  font-size: 1rem;
  margin-bottom: 1rem;
}

.featured-scroll-container {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  padding-bottom: 8px;
}

.featured-card {
  flex: 0 0 auto;
  width: 140px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease;
  scroll-snap-align: start;
}
.featured-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.featured-card img {
  width: 100%;
  height: 130px;
  object-fit: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.featured-card .card-content {
  padding: 12px 14px;
}
.featured-card .card-content .card-title {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 6px;
}
.featured-card .card-content .card-description {
  font-size: 13px;
  color: #555;
  height: 38px;
  overflow: hidden;
}

/* Optional: Scrollbar styling for better UX */
.featured-scroll-container::-webkit-scrollbar {
  height: 6px;
}

.featured-scroll-container::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 4px;
}

.featured-scroll-container {
  display: flex;
  overflow-x: auto;
  gap: 12px;
  align-items: stretch;
}

/* Ensure only skeleton cards have zero inner margins */
.user-pro .item.skeleton-item > div {
  margin: 0 !important;
}

/* Card edge behaviors */
.scroll .item {
  transition: border-radius 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
  margin-top: 5px;
}

@media (min-width: 993px) {
  /* Desktop: show square edge on hover */
  .scroll .item:hover {
    border-radius: 0 !important;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }
  .scroll .item:hover .img-display,
  .scroll .item:hover .video-display {
    border-radius: 0 !important;
  }
}
@media (max-width: 767px) {
  /* Mobile: full-width square cards */
  .example-container .user-pro .item {
    width: 100% !important;
    margin: 8px 0 !important;
    border-radius: 0 !important;
  }
  .example-container .user-pro img.img-display,
  .example-container .user-pro video.video-display {
    width: 100% !important;
    height: auto;
    border-radius: 0 !important;
  }
  /* Mobile: maintain 16:9 aspect ratio matching search component */
  .user-pro .item {
    /* Thumbnail wrapper maintains 16:9 aspect ratio */
  }
  .user-pro .item > div:first-child {
    aspect-ratio: 16/9 !important;
    border-radius: 0 !important;
    width: 100% !important;
  }
  .user-pro .item .img-display,
  .user-pro .item .video-display {
    width: 100% !important;
    height: 100% !important;
    border-radius: 0 !important;
    object-fit: cover !important;
    aspect-ratio: 16/9 !important;
  }
  /* Override search-style thumbnail to match search component on mobile */
  .video-thumbnail {
    aspect-ratio: 16/9 !important;
    border-radius: 0 !important;
    width: 100% !important;
  }
  .thumbnail-image,
  .thumbnail-video {
    width: 100% !important;
    height: 100% !important;
    border-radius: 0 !important;
    object-fit: cover !important;
  }
}
/* Overlay price badge to match search page */
.scroll .item .priceIcon-p,
.user-pro .item .priceIcon-p {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  background-color: rgba(33, 36, 39, 0.5);
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 6px;
  -webkit-backdrop-filter: saturate(120%);
          backdrop-filter: saturate(120%);
  margin: 0;
  border: none;
}
.scroll .item .priceIcon-p mat-label,
.user-pro .item .priceIcon-p mat-label {
  color: #ffffff !important;
  font-size: 16px !important;
}

.featured-card {
  flex: 0 0 auto;
  width: 250px;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
}

.card-content {
  padding: 10px;
}

.card-title {
  font-weight: bold;
  font-size: 14px;
}

.view-all-text {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-weight: 500;
  color: #007bff;
  cursor: pointer;
  white-space: nowrap;
}

.view-all-text:hover {
  text-decoration: underline;
}

/* Skeleton Loader Styles for Profile Section */
.skeleton-profile-card {
  background: #fff !important;
  border: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px;
  padding: 20px;
}

.skeleton-text {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  height: 16px;
  margin: 6px 0;
}
.skeleton-text.skeleton-username {
  height: 24px;
  width: 150px;
  margin-bottom: 10px;
}
.skeleton-text.skeleton-name {
  height: 20px;
  width: 200px;
  margin-bottom: 8px;
}
.skeleton-text.skeleton-description {
  height: 16px;
  width: 100%;
  margin-bottom: 6px;
}
.skeleton-text.skeleton-link {
  height: 14px;
  width: 120px;
  margin-bottom: 4px;
}
.skeleton-text.skeleton-stat-number {
  height: 24px;
  width: 40px;
  margin-bottom: 4px;
}
.skeleton-text.skeleton-stat-label {
  height: 14px;
  width: 60px;
}
.skeleton-text.skeleton-button {
  height: 32px;
  width: 120px;
  margin: 8px 0;
}

.skeleton-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
}
.skeleton-avatar.skeleton-large-avatar {
  width: 60px;
  height: 60px;
}

.skeleton-icon {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
}
.skeleton-icon.skeleton-qr-icon {
  width: 24px;
  height: 24px;
}

.skeleton-stats {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  padding: 15px 0;
  border-top: 1px solid #e0e0e0;
}

.skeleton-stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.skeleton-button-wrap {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 10px;
}

/* Search-page-style skeleton card (used in view-profile grid) */
.skeleton-card {
  background-color: #f9f9f9;
  border-radius: 12px;
  overflow: hidden;
}

.skeleton-thumbnail {
  width: 100%;
  height: 100%;
  display: block;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
}

/* Skeleton Loader Styles for Infinite Scroll */
.skeleton-item {
  background: #f9f9f9;
  border: none;
  border-radius: 12px;
  padding: 0;
  box-shadow: none;
  margin-bottom: 20px;
  overflow: hidden;
}

.skeleton-media {
  width: 100%;
  aspect-ratio: 16/9;
  height: auto;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 12px;
  margin-bottom: 12px;
}

.skeleton-text {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  height: 16px;
  margin: 6px 0;
}
.skeleton-text.title {
  height: 20px;
  width: 80%;
  margin-bottom: 8px;
}
.skeleton-text.subtitle {
  height: 14px;
  width: 60%;
  margin-bottom: 10px;
}
.skeleton-text.username {
  height: 14px;
  width: 100px;
}
.skeleton-text.price {
  height: 16px;
  width: 60px;
  margin-top: 8px;
}

.skeleton-info {
  display: flex;
  gap: 8px;
  padding: 0;
  align-items: center;
}

.skeleton-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  flex-shrink: 0;
}

.skeleton-details {
  flex: 1;
  min-width: 0;
}

.skeleton-user {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.skeleton-title {
  height: 14px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 6px;
  width: 72%;
}

.skeleton-channel {
  height: 12px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 4px;
  width: 48%;
}

.skeleton-meta {
  height: 11px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  width: 34%;
}

@keyframes skeleton-loading {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
/* Responsive Design for Skeleton */
@media (max-width: 768px) {
  .skeleton-item {
    padding: 0;
    margin-bottom: 15px;
  }
  .skeleton-media {
    aspect-ratio: 16/9;
    height: auto;
    border-radius: 0;
  }
}
@media (max-width: 480px) {
  .skeleton-item {
    padding: 0;
    margin-bottom: 10px;
  }
  .skeleton-media {
    aspect-ratio: 16/9;
    height: auto;
    border-radius: 0;
  }
  .skeleton-text {
    height: 14px;
  }
  .skeleton-text.title {
    height: 18px;
  }
  .skeleton-text.subtitle {
    height: 12px;
  }
}
/* Enforce circular avatar sizing for profile hero */
.profile-hero .example-header-image img {
  width: 120px !important;
  height: 120px !important;
  object-fit: cover !important;
  border-radius: 50% !important;
}

@media (min-width: 993px) {
  .profile-hero .example-header-image img {
    width: 150px !important;
    height: 150px !important;
  }
}
/* Ensure mat card avatar inside profile hero is square & circular */
.vp-wrapper .mat-mdc-card-header .mat-mdc-card-avatar img {
  width: 150px !important;
  height: 150px !important;
  object-fit: cover !important;
  border-radius: 50% !important;
}

/* Safety for very small devices */
@media (max-width: 360px) {
  .profile-hero .example-header-image img,
  .vp-wrapper .mat-mdc-card-header .mat-mdc-card-avatar img {
    width: 40vw !important;
    height: 40vw !important;
  }
}
/* Card avatars in flow lists - match search page dimensions */
.video-avatar {
  width: 24px !important;
  height: 24px !important;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
}

.video-avatar .avatar-image {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  border-radius: 50% !important;
  display: block !important;
}

/* Fallback where avatar is rendered via mat-card-avatar attribute */
.with-icon img[mat-card-avatar] {
  width: 36px !important;
  height: 36px !important;
  object-fit: cover !important;
  border-radius: 50% !important;
}

/* Desktop/default: search-like thumbnail styling */
.video-thumbnail {
  position: relative;
  width: 100% !important;
  aspect-ratio: 16/9 !important;
  background-color: #f5f5f5 !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  margin-bottom: 12px !important;
  /* Preserve original card dimensions - do not change */
  min-height: 0 !important;
  max-height: none !important;
}

.video-duration {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 3px;
  z-index: 2;
}
.video-duration .duration-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
  line-height: 13px;
}

.thumbnail-image,
.thumbnail-video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  display: block !important;
}

.sponsored-card-badge {
  position: absolute;
  bottom: 8px;
  left: 8px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 3px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  pointer-events: none;
}
.sponsored-card-badge mat-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
  line-height: 13px;
}

/* Legacy classes should behave the same as search cards */
.user-pro .item .img-display,
.user-pro .item .video-display {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  background-color: #f5f5f5 !important;
  border-radius: 12px !important;
}

/* Remove horizontal padding around tabs/content area */
.container-fluid.tabs-container,
.tabs-container.container-fluid {
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 24px !important; /* Add space after tabs */
}

.tabs-container .mat-mdc-tab-body-wrapper {
  padding: 0 !important;
}

/* Center the Builds empty-state message in the viewport while reusing noFlows */
.builds-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 60vh;
  margin-top: 0 !important;
}

/* Make sure the Builds empty-state spans full grid width and is centered in the grid */
.scroll.user-pro .builds-empty {
  grid-column: 1/-1;
  width: 100%;
  justify-self: center;
}

/* Ensure search-like 16:9 thumbnails on mobile with full width */
@media (max-width: 767px) {
  /* Mobile: full-width with square edges matching search component */
  .user-pro .item,
  .user-pro .item .video-thumbnail,
  .video-thumbnail {
    border-radius: 0 !important;
  }
  /* Maintain 16:9 aspect ratio on mobile matching search component */
  .video-thumbnail {
    aspect-ratio: 16/9 !important;
    margin-bottom: 12px !important;
    width: 100% !important;
  }
  /* Ensure wrapper containers maintain aspect ratio */
  .user-pro .item > div:first-child {
    aspect-ratio: 16/9 !important;
    width: 100% !important;
    border-radius: 0 !important;
  }
  .thumbnail-image,
  .thumbnail-video,
  .user-pro .item .img-display,
  .user-pro .item .video-display {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 0 !important;
  }
}
/* Fallback for browsers that do not support aspect-ratio */
@supports not (aspect-ratio: 1/1) {
  .video-thumbnail {
    position: relative;
    width: 100% !important;
    height: 0 !important;
    padding-top: 56.25% !important; /* 16:9 */
    overflow: hidden !important;
  }
  .thumbnail-image,
  .thumbnail-video {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    display: block !important;
  }
}
/* Align video info like search page */
.video-info {
  display: flex;
  gap: 0; /* no gap since avatar is now inside video-details */
}

/* Mobile-only tweak: slight left margin for video info row - match search page */
@media (max-width: 768px) {
  .video-info {
    margin-left: 5px; /* Match search page mobile */
  }
}
@media (max-width: 768px) {
  .video-details {
    margin-left: 5px !important; /* Match search page mobile */
  }
}
/* Video avatar styles - ensure visibility */
.video-avatar {
  width: 24px !important;
  height: 24px !important;
  border-radius: 50% !important;
  overflow: hidden !important;
  flex-shrink: 0 !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.avatar-image {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  display: block !important;
  border-radius: 50% !important;
}

.avatar-icon {
  width: 100% !important;
  height: 100% !important;
  font-size: 24px !important;
  color: #212427 !important;
  display: block !important;
}

.video-details {
  flex: 1;
  min-width: 0;
  display: flex; /* stacked layout */
  flex-direction: column;
  gap: 0; /* no spacing between rows */
  margin: 0;
  padding: 0;
}

.video-title-row {
  display: flex;
  align-items: flex-start;
  gap: 8px; /* proper spacing between title and menu */
  margin: 0; /* no extra space below title */
  margin-bottom: 0 !important;
  padding: 0;
  justify-content: space-between;
}

.video-title {
  font-size: 16px !important;
  font-weight: bold !important; /* match requested bold weight for profile cards */
  color: #000000 !important;
  margin: 0 !important;
  margin-bottom: 0px !important;
  line-height: 1.3 !important; /* proper line height for readability */
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important; /* allow 2 lines to show full title */
  line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  cursor: pointer !important;
  flex: 1 !important;
  min-width: 0 !important;
  padding: 0 !important;
  padding-right: 4px !important; /* space for menu button */
  word-wrap: break-word !important;
  word-break: break-word !important;
  white-space: normal !important; /* allow wrapping */
  -webkit-hyphens: auto !important;
          hyphens: auto !important; /* allow hyphenation for long words */
}

.video-title:hover {
  color: #666666;
}

.channel-meta-row {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  cursor: pointer !important;
  margin: 0 !important;
  margin-top: -2px !important; /* negative margin to eliminate gap */
  padding: 0 !important;
  flex-wrap: nowrap !important;
  line-height: 1 !important; /* minimal line height */
  justify-content: space-between !important;
  position: relative !important;
  width: 100% !important;
}

/* Group avatar and username together */
.channel-info {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  cursor: pointer !important;
  margin: 0 !important;
  flex-shrink: 0 !important;
}

.channel-meta-row > *:not(.video-views) {
  flex-shrink: 0 !important;
}

/* Ensure avatar and username stay together on same line */
.channel-info .video-avatar {
  flex-shrink: 0 !important;
  margin-right: 0 !important;
}

.channel-info .channel-name {
  font-size: 13px !important;
  color: #606060 !important;
  margin: 0px !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
  line-height: 1.3 !important;
  cursor: pointer !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
  display: inline-block !important;
}

.channel-name:hover {
  color: #000000;
}

/* YouTube-style collab: overlapping avatars + "name and @coauthor" */
.avatar-stack {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.avatar-stack .video-avatar {
  position: relative;
  z-index: 1;
}
.avatar-stack .collab-avatar-overlap {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  margin-left: -7px;
  border: 2px solid #fff;
  z-index: 2;
  position: relative;
  flex-shrink: 0;
}
.avatar-stack .collab-avatar-extra {
  position: relative;
  width: 20px;
  height: 20px;
  margin-left: -7px;
  z-index: 3;
  flex-shrink: 0;
  cursor: pointer;
}
.avatar-stack .collab-avatar-extra .collab-extra-img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  display: block;
}
.avatar-stack .collab-avatar-extra .collab-extra-badge {
  position: absolute;
  bottom: -3px;
  right: -4px;
  background: #3b82f6;
  color: #fff;
  font-size: 7px;
  font-weight: 700;
  border-radius: 8px;
  padding: 1px 3px;
  line-height: 1.2;
  white-space: nowrap;
}
.avatar-stack .collab-avatar-overlap-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  margin-left: -7px;
  color: #bbb;
  z-index: 2;
  position: relative;
  flex-shrink: 0;
  background: #f0f0f0;
  border-radius: 50%;
  border: 2px solid #fff;
  line-height: 20px;
}

.collab-sep {
  color: #888;
  font-weight: 400;
  font-size: 11px;
}

.collab-coname {
  font-weight: 500;
  cursor: pointer;
}
.collab-coname:hover {
  text-decoration: underline;
}

.collab-extra-count-text {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
}
.collab-extra-count-text:hover {
  text-decoration: underline;
}

/* Wrapper that provides positioning context for the popup */
.avatar-stack-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* Cursor hint when avatar stack is clickable */
.collab-stack-clickable {
  cursor: pointer;
}

/* Collaborators centred popup backdrop */
.collab-popup-backdrop {
  position: fixed;
  inset: 0;
  z-index: 499;
  background: rgba(0, 0, 0, 0.45);
}

/* Collaborators centred popup */
.collab-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 500;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22), 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px 16px 14px;
  width: 300px;
}
.collab-popup .collab-popup-title {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
  margin-bottom: 10px;
  text-align: center;
}
.collab-popup .collab-popup-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s;
}
.collab-popup .collab-popup-card:hover {
  background: #f5f7fa;
}
.collab-popup .collab-popup-avatar-wrap {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  border: 2px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
}
.collab-popup .collab-popup-pic {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.collab-popup .collab-popup-icon {
  font-size: 34px;
  width: 34px;
  height: 34px;
  color: #9ca3af;
  line-height: 1;
}
.collab-popup .collab-popup-uname {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.video-views {
  margin: 0 !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  color: #1d67a3 !important;
  background-color: #e3f2fd !important;
  padding: 3px 8px !important;
  border-radius: 4px !important;
  white-space: nowrap !important;
  display: inline-block !important;
  line-height: 1.2 !important;
  letter-spacing: 0.3px !important;
  align-self: center !important;
  margin-left: auto !important;
  flex-shrink: 0 !important;
}

.review-card-profile {
  padding: 24px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
  transition: all 0.2s;
}
.review-card-profile:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.review-card-profile .review-header-profile {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}
.review-card-profile .review-header-profile .reviewer-info-profile {
  display: flex;
  align-items: center;
  gap: 12px;
}
.review-card-profile .review-header-profile .reviewer-info-profile .reviewer-avatar-profile {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  color: #4f46e5;
  flex-shrink: 0;
}
.review-card-profile .review-header-profile .reviewer-info-profile .reviewer-details-profile h4 {
  font-weight: 700;
  font-size: 16px;
  color: #0f172a;
  margin: 0 0 4px 0;
}
.review-card-profile .review-header-profile .reviewer-info-profile .reviewer-details-profile .review-rating-profile {
  display: flex;
  align-items: center;
  gap: 8px;
}
.review-card-profile .review-header-profile .reviewer-info-profile .reviewer-details-profile .review-rating-profile .review-star-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: #cbd5e1;
}
.review-card-profile .review-header-profile .reviewer-info-profile .reviewer-details-profile .review-rating-profile .review-star-icon.filled-star {
  color: #f59e0b;
}
.review-card-profile .review-header-profile .reviewer-info-profile .reviewer-details-profile .review-rating-profile .review-date-profile {
  font-size: 12px;
  color: #94a3b8;
}
.review-card-profile .review-title-profile {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px 0;
}
.review-card-profile .review-text-profile {
  color: #475569;
  line-height: 1.6;
  margin: 0 0 12px 0;
}
.review-card-profile .review-flow-link {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
}
.review-card-profile .review-flow-link mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #64748b;
}
.review-card-profile .review-flow-link a {
  color: #f59e0b;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
}
.review-card-profile .review-flow-link a:hover {
  text-decoration: underline;
}

.skeleton-review-card {
  padding: 24px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  margin-bottom: 16px;
}
.skeleton-review-card .skeleton-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  margin-bottom: 12px;
}
.skeleton-review-card .skeleton-title {
  height: 20px;
  width: 60%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 8px;
}
.skeleton-review-card .skeleton-content {
  height: 16px;
  width: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 8px;
}
.skeleton-review-card .skeleton-content:last-child {
  width: 80%;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
/* Dark mode overrides for user/view profile pages */
:host-context(body.theme-dark) {
  /* Search-style skeleton card in dark mode */
  /* Grid skeleton cards: visible card shape against dark page */
  /* Grid skeleton shimmer — high enough contrast to be clearly visible */
  /* Profile header skeleton + tab card skeletons — same visible shimmer */
  /* Profile card header shimmer */
  /* Review card inner shimmer elements in dark mode */
  /* Match search .video-card: no full-bleed tile behind title/meta — only thumb uses #111827 */
  /* View-profile / own-profile grids use same classes as search */
  /* Collaborators popup — dark mode */
}
:host-context(body.theme-dark) .content-status-badge {
  background: rgba(255, 255, 255, 0.08);
  color: #d0d5dd;
}
:host-context(body.theme-dark) .content-status-badge[data-state=in-review] {
  background: rgba(181, 71, 8, 0.2);
  color: #fdba74;
}
:host-context(body.theme-dark) .content-status-badge[data-state=rejected] {
  background: rgba(240, 68, 56, 0.16);
  color: #fda29b;
}
:host-context(body.theme-dark) .content-status-badge[data-state=approved] {
  background: rgba(18, 183, 106, 0.16);
  color: #75e0a7;
}
:host-context(body.theme-dark) .content-status-badge[data-state=pack] {
  background: rgba(68, 76, 231, 0.2);
  color: #a4bcfd;
}
:host-context(body.theme-dark) .example-container,
:host-context(body.theme-dark) mat-sidenav-content.example-container,
:host-context(body.theme-dark) .gridgroup-wrap,
:host-context(body.theme-dark) .vp-wrapper,
:host-context(body.theme-dark) .tabs-container,
:host-context(body.theme-dark) .featured-section {
  background: #0a0c10 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .vp-wrapper,
:host-context(body.theme-dark) .skeleton-profile-card,
:host-context(body.theme-dark) .featured-card,
:host-context(body.theme-dark) .review-card-profile,
:host-context(body.theme-dark) .skeleton-review-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .skeleton-card {
  background-color: #1e293b !important;
  border: 1px solid rgba(148, 163, 184, 0.15) !important;
}
:host-context(body.theme-dark) .skeleton-card .skeleton-thumbnail,
:host-context(body.theme-dark) .skeleton-card .skeleton-title,
:host-context(body.theme-dark) .skeleton-card .skeleton-channel,
:host-context(body.theme-dark) .skeleton-card .skeleton-meta,
:host-context(body.theme-dark) .skeleton-card .video-avatar .skeleton-avatar {
  background: linear-gradient(90deg, #334155 25%, #64748b 50%, #334155 75%) !important;
  background-size: 200% 100% !important;
}
:host-context(body.theme-dark) .skeleton-item {
  background: #1e293b !important;
  border: 1px solid rgba(148, 163, 184, 0.15) !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .skeleton-item .skeleton-media,
:host-context(body.theme-dark) .skeleton-item .skeleton-text,
:host-context(body.theme-dark) .skeleton-item .skeleton-avatar,
:host-context(body.theme-dark) .skeleton-item .skeleton-title,
:host-context(body.theme-dark) .skeleton-item .skeleton-channel,
:host-context(body.theme-dark) .skeleton-item .skeleton-meta {
  background: linear-gradient(90deg, #334155 25%, #64748b 50%, #334155 75%) !important;
  background-size: 200% 100% !important;
}
:host-context(body.theme-dark) .skeleton-profile-card .skeleton-text,
:host-context(body.theme-dark) .skeleton-profile-card .skeleton-avatar,
:host-context(body.theme-dark) .skeleton-profile-card .skeleton-icon,
:host-context(body.theme-dark) .skeleton-item .skeleton-info .skeleton-avatar,
:host-context(body.theme-dark) .skeleton-item .skeleton-details .skeleton-title,
:host-context(body.theme-dark) .skeleton-item .skeleton-details .skeleton-channel,
:host-context(body.theme-dark) .skeleton-item .skeleton-details .skeleton-meta,
:host-context(body.theme-dark) .skeleton-item .skeleton-text.title,
:host-context(body.theme-dark) .skeleton-item .skeleton-text.subtitle,
:host-context(body.theme-dark) .skeleton-item .skeleton-text.username,
:host-context(body.theme-dark) .skeleton-item .skeleton-user .skeleton-avatar,
:host-context(body.theme-dark) .skeleton-item .skeleton-user .skeleton-text {
  background: linear-gradient(90deg, #334155 25%, #64748b 50%, #334155 75%) !important;
  background-size: 200% 100% !important;
}
:host-context(body.theme-dark) .skeleton-profile-card .skeleton-text,
:host-context(body.theme-dark) .skeleton-profile-card .skeleton-avatar,
:host-context(body.theme-dark) .skeleton-profile-card .skeleton-icon {
  background: linear-gradient(90deg, #1f2937 25%, #4b5563 50%, #1f2937 75%) !important;
  background-size: 200% 100% !important;
}
:host-context(body.theme-dark) .skeleton-profile-card {
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .skeleton-stats {
  border-top-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .skeleton-review-card .skeleton-avatar,
:host-context(body.theme-dark) .skeleton-review-card .skeleton-title,
:host-context(body.theme-dark) .skeleton-review-card .skeleton-content {
  background: linear-gradient(90deg, #1f2937 25%, #4b5563 50%, #1f2937 75%) !important;
  background-size: 200% 100% !important;
}
:host-context(body.theme-dark) .user-pro .item:not(.skeleton-item) {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .userico {
  background: #0a0c10 !important;
}
:host-context(body.theme-dark) .gridgroup-wrap .mat-mdc-tab-header,
:host-context(body.theme-dark) .gridgroup-wrap .mat-mdc-tab-group .mat-mdc-tab-header,
:host-context(body.theme-dark) .tabs-container {
  background: #111827 !important;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .vp-wrapper .vp-userdetails,
:host-context(body.theme-dark) .vp-wrapper .vp-userdetails span,
:host-context(body.theme-dark) .video-title,
:host-context(body.theme-dark) .profile-title-row h2,
:host-context(body.theme-dark) .profile-stats .stat .stat-number,
:host-context(body.theme-dark) .profile-stat-bar .profile-stat-item .value,
:host-context(body.theme-dark) .section-title,
:host-context(body.theme-dark) .card-title,
:host-context(body.theme-dark) .review-title-profile,
:host-context(body.theme-dark) .reviewer-details-profile h4,
:host-context(body.theme-dark) .review-text-profile,
:host-context(body.theme-dark) .noFlows h4,
:host-context(body.theme-dark) .noFlows p {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .channel-name,
:host-context(body.theme-dark) .video-meta,
:host-context(body.theme-dark) .video-date,
:host-context(body.theme-dark) .video-views,
:host-context(body.theme-dark) .profile-stats .stat .stat-label,
:host-context(body.theme-dark) .profile-stat-bar .profile-stat-item .label,
:host-context(body.theme-dark) .view-all-text,
:host-context(body.theme-dark) .card-description,
:host-context(body.theme-dark) .review-date-profile {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .video-thumbnail,
:host-context(body.theme-dark) .user-pro .item > div:first-child {
  background: #111827 !important; /* same as search .video-thumbnail */
}
:host-context(body.theme-dark) .user-pro .item .img-display,
:host-context(body.theme-dark) .user-pro .item .video-display {
  background-color: #111827 !important;
}
:host-context(body.theme-dark) .user-pro .item p.lf13 {
  color: #f3f4f6 !important; /* search .video-title */
}
:host-context(body.theme-dark) .user-pro .item .with-icon p {
  color: #9ca3af !important; /* search .channel-name */
}
:host-context(body.theme-dark) .user-pro .item p:not(.lf13):not(.with-icon p) {
  color: #9ca3af !important;
}
:host-context(body.theme-dark) .user-pro .video-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .user-pro .video-title:hover {
  color: #d1d5db !important; /* search */
}
:host-context(body.theme-dark) .user-pro .channel-name,
:host-context(body.theme-dark) .user-pro .channel-info .channel-name {
  color: #9ca3af !important;
}
:host-context(body.theme-dark) .user-pro .channel-name:hover {
  color: #e5e7eb !important; /* search .channel-name:hover */
}
:host-context(body.theme-dark) .avatar-stack .collab-avatar-overlap,
:host-context(body.theme-dark) .avatar-stack .collab-avatar-overlap-icon {
  border-color: #1f2937;
  background: #374151;
}
:host-context(body.theme-dark) .avatar-stack .collab-avatar-overlap-icon {
  color: #6b7280;
}
:host-context(body.theme-dark) .avatar-stack .collab-avatar-extra {
  border-color: #1f2937;
  background: #374151;
  color: #d1d5db;
}
:host-context(body.theme-dark) .collab-sep {
  color: #6b7280;
}
:host-context(body.theme-dark) .collab-coname {
  color: #9ca3af;
}
:host-context(body.theme-dark) .user-pro .video-views,
:host-context(body.theme-dark) .user-pro .video-time {
  background-color: rgba(94, 161, 216, 0.2) !important;
  color: #93c5fd !important;
}
@media (min-width: 993px) {
  :host-context(body.theme-dark) .example-container .vp-wrapper {
    border-bottom-color: rgba(148, 163, 184, 0.2) !important;
  }
}
:host-context(body.theme-dark) .mobile-search-header {
  background: transparent !important;
  border-color: transparent !important;
}
:host-context(body.theme-dark) .mobile-search-header .profile-mobile-search-box .mobile-search-field .app-search-input {
  background: #111827 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .mobile-search-header .profile-search-toggle,
:host-context(body.theme-dark) .mobile-search-header .profile-mobile-search-box .mobile-search-field .cancel-icon-button,
:host-context(body.theme-dark) .mobile-search-header .profile-mobile-search-box .mobile-search-field .search-icon-button {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .mobile-search-header .profile-search-toggle:hover,
:host-context(body.theme-dark) .mobile-search-header .profile-mobile-search-box .mobile-search-field .cancel-icon-button:hover,
:host-context(body.theme-dark) .mobile-search-header .profile-mobile-search-box .mobile-search-field .search-icon-button:hover {
  background: #273449 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .textcolor,
:host-context(body.theme-dark) .textcolor:hover,
:host-context(body.theme-dark) .profile-stat-bar .profile-stat-item .label,
:host-context(body.theme-dark) .profile-stat-bar .profile-stat-item .value {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .textcolor {
  background: transparent !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .collab-popup {
  background: #1f2937;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.6), 0 2px 10px rgba(0, 0, 0, 0.4);
}
:host-context(body.theme-dark) .collab-popup .collab-popup-title {
  color: #64748b;
  border-bottom-color: rgba(148, 163, 184, 0.15);
}
:host-context(body.theme-dark) .collab-popup .collab-popup-card:hover {
  background: #374151;
}
:host-context(body.theme-dark) .collab-popup .collab-popup-avatar-wrap {
  border-color: #374151;
  background: #111827;
}
:host-context(body.theme-dark) .collab-popup .collab-popup-icon {
  color: #6b7280;
}
:host-context(body.theme-dark) .collab-popup .collab-popup-uname {
  color: #e2e8f0;
}

/* Membership (Applications / Teams) cards reuse guide card layout;
   cover uses a default app/team icon instead of a photo. */
.membership-thumb {
  background: #eef5fb !important;
}

.membership-thumb--app {
  background: linear-gradient(145deg, #6bb0e0 0%, #4a8fc4 55%, #3576a8 100%) !important;
}

.membership-thumb--team {
  background: linear-gradient(145deg, #7bc0a8 0%, #4f9e86 55%, #3a7d68 100%) !important;
}

.membership-cover-fallback {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
}

.membership-cover-icon {
  font-size: 56px !important;
  width: 56px !important;
  height: 56px !important;
  line-height: 56px !important;
  color: rgba(255, 255, 255, 0.95);
}

.scroll.user-pro .item.active {
  outline: 2px solid #5ea1d8;
  outline-offset: 2px;
}

.scroll.user-pro .item.active .video-thumbnail {
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.35);
}

.profile-display-name {
  display: block;
  width: 100%;
  font-size: 14px;
  color: #666666;
  margin: 4px 0 0;
}

.profile-identity {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  flex: 1 1 auto;
}

/* Preserve card dimensions - ensure same as user-profile */
.user-pro .item {
  /* Preserve original card dimensions - width controlled by grid, height by content */
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  min-height: auto !important;
  height: auto !important;
}

.user-pro .item .video-thumbnail {
  /* Preserve original card dimensions - do not change */
  aspect-ratio: 16/9 !important;
  width: 100% !important;
  min-height: 0 !important;
  max-height: none !important;
}

.video-duration {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 3px;
  z-index: 2;
}
.video-duration .duration-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
  line-height: 13px;
}

.sponsored-card-badge {
  position: absolute;
  bottom: 8px;
  left: 8px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 3px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  pointer-events: none;
}
.sponsored-card-badge mat-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
  line-height: 13px;
}

/* Mobile grid layout matching search component */
@media (max-width: 768px) {
  .example-container .user-pro {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px; /* Match search page mobile gap */
    padding: 0 !important; /* Match search page - no padding */
  }
  /* Mobile-only tweak: slight left margin for video info row - match search page */
  .video-info {
    margin-left: 5px; /* Match search page mobile */
  }
}
@media (max-width: 480px) {
  .example-container .user-pro {
    grid-template-columns: 1fr;
    gap: 16px; /* Match search page mobile gap */
    padding: 0 !important; /* Match search page - no padding */
  }
}
/* Mobile: full-width with square edges matching search component */
@media (max-width: 767px) {
  .user-pro .item,
  .user-pro .item .video-thumbnail,
  .video-thumbnail {
    border-radius: 0 !important;
  }
  .user-pro .item > div:first-child {
    border-radius: 0 !important;
    margin-bottom: 12px; /* Match search page */
  }
  .thumbnail-image,
  .thumbnail-video {
    border-radius: 0 !important;
  }
  /* Card content - match search page (no padding on card content) */
  .user-pro .item > div:last-child {
    padding: 0 !important; /* Match search page - no padding on card content */
  }
}
/* Ensure flow title wraps to next line if not fitting */
.video-title {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  -webkit-hyphens: auto !important;
          hyphens: auto !important;
  -webkit-line-clamp: 2 !important;
  line-clamp: 2 !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* Ensure profile image and username are on same line like search page */
.channel-meta-row {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  flex-wrap: nowrap !important;
  width: 100% !important;
  justify-content: space-between !important;
}

/* Group avatar and username together */
.channel-info {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  cursor: pointer !important;
  margin: 0 !important;
  flex-shrink: 0 !important;
}

.channel-info .video-avatar {
  flex-shrink: 0 !important;
  margin-right: 0 !important;
}

.channel-info .channel-name {
  white-space: nowrap !important;
  flex-shrink: 0 !important;
  display: inline-block !important;
  margin: 0 !important;
  font-size: 13px !important;
  color: #606060 !important;
}

/* YouTube-style collab: overlapping avatars + "name and @coauthor" */
.avatar-stack {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.avatar-stack .video-avatar {
  position: relative;
  z-index: 1;
}
.avatar-stack .collab-avatar-overlap {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  margin-left: -7px;
  border: 2px solid #fff;
  z-index: 2;
  position: relative;
  flex-shrink: 0;
}
.avatar-stack .collab-avatar-extra {
  position: relative;
  width: 20px;
  height: 20px;
  margin-left: -7px;
  z-index: 3;
  flex-shrink: 0;
  cursor: pointer;
}
.avatar-stack .collab-avatar-extra .collab-extra-img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  display: block;
}
.avatar-stack .collab-avatar-extra .collab-extra-badge {
  position: absolute;
  bottom: -3px;
  right: -4px;
  background: #3b82f6;
  color: #fff;
  font-size: 7px;
  font-weight: 700;
  border-radius: 8px;
  padding: 1px 3px;
  line-height: 1.2;
  white-space: nowrap;
}
.avatar-stack .collab-avatar-overlap-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  margin-left: -7px;
  color: #bbb;
  z-index: 2;
  position: relative;
  flex-shrink: 0;
  background: #f0f0f0;
  border-radius: 50%;
  border: 2px solid #fff;
  line-height: 20px;
}

.collab-sep {
  color: #888;
  font-weight: 400;
  font-size: 11px;
}

.collab-coname {
  font-weight: 500;
  cursor: pointer;
}
.collab-coname:hover {
  text-decoration: underline;
}

.collab-extra-count-text {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
}
.collab-extra-count-text:hover {
  text-decoration: underline;
}

.avatar-stack-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.collab-stack-clickable {
  cursor: pointer;
}

.collab-popup-backdrop {
  position: fixed;
  inset: 0;
  z-index: 499;
  background: rgba(0, 0, 0, 0.45);
}

.collab-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 500;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22), 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px 16px 14px;
  width: 300px;
}
.collab-popup .collab-popup-title {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
  margin-bottom: 10px;
  text-align: center;
}
.collab-popup .collab-popup-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s;
}
.collab-popup .collab-popup-card:hover {
  background: #f5f7fa;
}
.collab-popup .collab-popup-avatar-wrap {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  border: 2px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
}
.collab-popup .collab-popup-pic {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.collab-popup .collab-popup-icon {
  font-size: 34px;
  width: 34px;
  height: 34px;
  color: #9ca3af;
  line-height: 1;
}
.collab-popup .collab-popup-uname {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.video-views {
  margin-left: auto !important;
  flex-shrink: 0 !important;
}

.primary-btn {
  background: #5ea1d8;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-family: "Raleway", sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.primary-btn:hover {
  background: #4a8fc4;
}
.primary-btn .primary-btn:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}
.primary-btn .btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  display: inline-block;
  animation: follow-spin 0.7s linear infinite;
}
@keyframes follow-spin {
  to {
    transform: rotate(360deg);
  }
}

.primary-btn.following {
  background: #f0f0f0;
  color: #5ea1d8;
  border: 1px solid #5ea1d8;
}

.secondary-btn {
  background: transparent;
  border: 1px solid #5ea1d8;
  border-radius: 6px;
  color: #5ea1d8;
  padding: 8px 16px;
  font-family: "Raleway", sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.secondary-btn:hover {
  background: rgba(94, 161, 216, 0.1);
}

.actions-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.profile-stats {
  display: flex;
  gap: 24px;
  margin-top: 20px;
  flex-wrap: wrap;
}
.profile-stats .stat {
  display: flex;
  flex-direction: column;
  min-width: 100px;
}
.profile-stats .stat .stat-number {
  font-size: 18px;
  font-weight: 700;
  color: #212427 !important;
}
.profile-stats .stat .stat-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #606060 !important;
}

.profile-stat-bar {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  padding: 16px 0;
}
.profile-stat-bar .profile-stat-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.profile-stat-bar .profile-stat-item .label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #606060 !important;
}
.profile-stat-bar .profile-stat-item .value {
  font-size: 18px;
  font-weight: 700;
  color: #212427 !important;
}

:host-context(body.theme-dark) {
  /* Outrank .channel-info .channel-name light color so grid matches search page */
  /* Collaborators popup — dark mode */
}
:host-context(body.theme-dark) .primary-btn.following {
  background: #1f2937 !important;
  color: #93c5fd !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .secondary-btn {
  border-color: #93c5fd !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .secondary-btn:hover {
  background: rgba(147, 197, 253, 0.12) !important;
}
:host-context(body.theme-dark) .profile-stats .stat .stat-number,
:host-context(body.theme-dark) .profile-stat-bar .profile-stat-item .value {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .profile-stats .stat .stat-label,
:host-context(body.theme-dark) .profile-stat-bar .profile-stat-item .label {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .channel-info .channel-name,
:host-context(body.theme-dark) .user-pro .channel-name {
  color: #9ca3af !important;
}
:host-context(body.theme-dark) .avatar-stack .collab-avatar-overlap,
:host-context(body.theme-dark) .avatar-stack .collab-avatar-overlap-icon {
  border-color: #1f2937;
  background: #374151;
}
:host-context(body.theme-dark) .avatar-stack .collab-avatar-overlap-icon {
  color: #6b7280;
}
:host-context(body.theme-dark) .avatar-stack .collab-avatar-extra {
  border-color: #1f2937;
  background: #374151;
  color: #d1d5db;
}
:host-context(body.theme-dark) .collab-sep {
  color: #6b7280;
}
:host-context(body.theme-dark) .collab-coname {
  color: #9ca3af;
}
:host-context(body.theme-dark) .collab-popup {
  background: #1f2937;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.6), 0 2px 10px rgba(0, 0, 0, 0.4);
}
:host-context(body.theme-dark) .collab-popup .collab-popup-title {
  color: #64748b;
  border-bottom-color: rgba(148, 163, 184, 0.15);
}
:host-context(body.theme-dark) .collab-popup .collab-popup-card:hover {
  background: #374151;
}
:host-context(body.theme-dark) .collab-popup .collab-popup-avatar-wrap {
  border-color: #374151;
  background: #111827;
}
:host-context(body.theme-dark) .collab-popup .collab-popup-icon {
  color: #6b7280;
}
:host-context(body.theme-dark) .collab-popup .collab-popup-uname {
  color: #e2e8f0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/view-profile/view-profile.component.scss","webpack://./src/app/pages/user-profile/user-profile.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EAGE,uDAAA;EAOA,+DAAA;EACA,yBAAA;EAEA,gDAAA;ADPF;ACFE;EAEE,wBAAA;EACA,wBAAA;ADGJ;ACIE;EACE,4BAAA;ADFJ;;ACMA;EACE,6BAAA;ADHF;;ACMA;EACE;IACE,2BAAA;EDHF;AACF;ACMA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;ADJF;;ACOA;EACE,WAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;ADJF;;ACOA;EAKE,gBAAA;EAEA,kBAAA;EACA,oFAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;ADTF;ACWE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;ADTJ;;ACaA;EACE,wBAAA;EACA,2BAAA;ADVF;;ACeA;EACE,WAAA;ADZF;;ACeA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,cAAA;ADZF;;ACeA;EACE,kBAAA;EAGA,qBAAA;EACA,qFAAA;ADdF;;ACiBA;;;EAGE,0BAAA;ADdF;;ACiBA;EACE,0BAAA;EACA,YAAA;ADdF;;ACiBA;EACE,eAAA;EACA,YAAA;ADdF;;ACiBA;EACE,aAAA;ADdF;;ACiBA;EACE,aAAA;EACA,mBAAA;ADdF;;ACiBA;EACE,yBAAA;EACA,YAAA;ADdF;;ACiBA;EACE,mBAAA;EACA,sBAAA;ADdF;;ACiBA;EACE,YAAA;EACA,gBAAA;EACA,oBAAA;EAEA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,UAAA;ADfF;;ACkBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;ADfF;;ACkBA;EACE,YAAA;ADfF;;ACkBA;EACE,YAAA;ADfF;;ACkBA;;EAEE,cAAA;EACA,yBAAA;ADfF;;ACkBA;EACE,WAAA;ADfF;;ACkBA;EACE,cAAA;ADfF;;ACkBA;EACE,cAAA;ADfF;;ACkBA;EACE,cAAA;ADfF;;ACkBA;EACE,wBAAA;ADfF;ACiBE;EACE,eAAA;ADfJ;;ACmBA,yCAAA;AACA;EACE,eAAA;EACA,OAAA;EACA,0BAAA,EAAA,qCAAA;EACA,gBAAA,EAAA,gDAAA;EACA,0BAAA,EAAA,mCAAA;EAEA,iEAAA;ADjBF;ACkBE;;EAEE,gBAAA;EACA,MAAA,EAAA,iDAAA;EACA,UAAA;EACA,mBAAA;ADhBJ;ACmBE;EACE,aAAA;ADjBJ;ACoBE;EACE,aAAA;ADlBJ;ACqBE;EACE,iBAAA;EACA,gBAAA;EACA,iDAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;ADnBJ;ACsBE;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;ADpBJ;;ACwBA,6CAAA;AAEA;EACE,aAAA;EACA,0BAAA;EACA,UAAA,EAAA,mCAAA;EACA,0BAAA,EAAA,8CAAA;EACA,oBAAA,EAAA,+BAAA;EAEA,kBAAA;ADvBF;ACyBE;EACE,aAAA;ADvBJ;AC0BE;EAEE,WAAA;EACA,gBAAA;EACA,SAAA,EAAA,4BAAA;EACA,0BAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;ADzBJ;AC2BI;EACE,UAAA;EACA,aAAA;ADzBN;AC4BI;EACE,oDAAA;AD1BN;AC6BI;EACE,yBAAA;EACA,0BAAA;AD3BN;AC+BE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EA8BA,0CAAA;EAgCA,2CAAA;EAYA,kDAAA;EAMA,wEAAA;EAaA,4CAAA;EA4BA,oCAAA;EA8CA,+DAAA;EA0BA,sBAAA;ADtNJ;ACuBI;EACE,iBAAA,EAAA,2BAAA;EAEA,uDAAA;ADtBN;ACuBM;EAEE,wBAAA;EACA,wBAAA;ADtBR;AC0BI;EACE,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,+DAAA;EACA,2BAAA;EACA,uBAAA;ADxBN;AC4BI;EApCF;IAqCI,oBAAA,EAAA,sEAAA;EDzBJ;EC2BI;IACE,wBAAA;IACA,yBAAA;IACA,0BAAA;IACA,4BAAA,EAAA,uCAAA;IAEA,uDAAA;ED1BN;EC2BM;IAEE,wBAAA;IACA,wBAAA;ED1BR;EC8BI;IACE,oBAAA;IACA,qBAAA;ED5BN;EC+BI;IACE,mBAAA;ED7BN;AACF;ACgCI;EACE,2BAAA;AD9BN;ACkCI;EACE,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;ADhCN;ACoCI;EACE,kCAAA;EACA,qBAAA;ADlCN;ACsCI;;EAEE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;ADpCN;ACwCI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EAEA,gBAAA;EAMA,qBAAA;EAMA,8BAAA;ADjDN;ACsCM;EACE,QAAA;EACA,SAAA;ADpCR;ACwCM;EACE,QAAA;EACA,SAAA;ADtCR;AC0CM;EACE,QAAA;EACA,SAAA;ADxCR;AC8CM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AD5CR;ACgDI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AD9CN;ACiDI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AD/CN;ACiDM;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AD/CR;ACkDM;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;ADhDR;ACqDI;EACE,kBAAA;ADnDN;ACsDI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,uCAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,uCAAA;UAAA,+BAAA;EACA,SAAA;EACA,YAAA;ADpDN;ACsDM;EACE,yBAAA;ADpDR;ACyDI;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;ADvDN;;AC4DA,sEAAA;AACA;EACE;IACE,yBAAA,EAAA,mBAAA;IACA,iCAAA;IACA,uBAAA,EAAA,kCAAA;IACA,+BAAA;EDzDF;EC4DA;IACE,6BAAA;IACA,iBAAA;IACA,uBAAA;IACA,4BAAA;IACA,sBAAA;ED1DF;EC6DA;IACE,uBAAA;IACA,4BAAA;IACA,sBAAA;IACA,oBAAA;IACA,wBAAA,EAAA,8BAAA;ED3DF;EC8DA;IACE,0BAAA;IACA,6CAAA;IACA,uBAAA,EAAA,gDAAA;IACA,0BAAA,EAAA,iCAAA;IAEA,cAAA,EAAA,6BAAA;IACA,mBAAA;ED7DF;ECgEA,6CAAA;EACA;;IAEE,iBAAA;IACA,cAAA;ED9DF;ECiEA,0CAAA;EACA;IACE,0BAAA;IACA,2BAAA;ED/DF;ECkEA,6DAAA;EACA;IACE,yBAAA;EDhEF;ECkEA;IACE,yBAAA;EDhEF;ECkEA;IACE,yBAAA;EDhEF;ECkEA;IACE,gCAAA;IACA,sBAAA;IACA,4BAAA;IACA,kBAAA;EDhEF;AACF;ACmEA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,4CAAA;EACA,UAAA;EACA,uBAAA;ADjEF;ACmEE;EACE,2BAAA;ADjEJ;ACoEE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;ADlEJ;ACoEI;EACE,aAAA;EACA,sBAAA;EACA,OAAA;ADlEN;ACsEM;;EAEE,cAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;ADpER;ACwEI;EACE,qBAAA;EACA,mBAAA;ADtEN;ACyEI;EAEE,mBAAA;EACA,eAAA;EACA,yBAAA;ADxEN;AC2EI;EACE,aAAA;ADzEN;AC6EE;EACE,aAAA;EACA,gBAAA;EACA,WAAA;EAEA,kBAAA;EACA,gBAAA;AD5EJ;AC8EI;EACE,WAAA;EACA,YAAA;EACA,WAAA;AD5EN;AC8EM;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AD5ER;;ACkFA,gCAAA;AACA;EACE,kBAAA;EACA,cAAA;AD/EF;;ACiFA;EACE,UAAA;AD9EF;;ACgFA;EACE,gBAAA;AD7EF;;ACgFA;EACE;IACE,iBAAA;IACA,aAAA;IACA,mBAAA;IACA,SAAA;ED7EF;EC+EA;IACE,kBAAA;IACA,cAAA;ED7EF;EC+EA;IACE,gBAAA;IACA,cAAA;IACA,YAAA;ED7EF;EC+EA;;IAEE,uBAAA;IACA,wBAAA;ED7EF;AACF;ACgFA,WAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,oDAAA;AD9EF;;ACiFA,+BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AD9EF;;ACiFA;EACE,0CAAA;EACA,oCAAA;EACA,cAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,0DAAA;AD9EF;ACgFE;EACE,mCAAA;EACA,qBAAA;AD9EJ;;ACkFA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AD/EF;ACiFE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AD/EJ;ACiFI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AD/EN;ACkFI;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;ADhFN;;ACqFA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;ADlFF;ACoFE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;ADlFJ;ACoFI;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;ADlFN;ACqFI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;ADnFN;;ACuFA;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;ADpFF;;ACuFA,4CAAA;AACA;EACE;IACE,mBAAA;EDpFF;ECsFE;IACE,wBAAA;IACA,sBAAA;IACA,oBAAA;IACA,mBAAA;EDpFJ;AACF;ACwFA,yDAAA;AACA;EACE;IACE,eAAA;IACA,uBAAA;EDtFF;ECyFA;IACE,cAAA;IACA,YAAA;IACA,aAAA;IACA,eAAA;IACA,mBAAA;IACA,QAAA;EDvFF;ECyFE;IACE,cAAA;IACA,YAAA;EDvFJ;ECyFI;IACE,sBAAA;IACA,yBAAA;EDvFN;EC2FE;IACE,cAAA;IACA,yBAAA;EDzFJ;EC6FA;IACE,cAAA;IACA,eAAA;IACA,aAAA;IACA,SAAA;IACA,eAAA;IACA,mBAAA;ED3FF;EC6FE;IACE,wBAAA;IACA,oBAAA;IACA,mBAAA;IACA,sBAAA;ED3FJ;AACF;AC+FA,iBAAA;AACA;EACE,yBAAA;EACA,qBAAA;AD7FF;;AC+FA;;EAEE,WAAA;AD5FF;;AC+FA;EACE,0BAAA;AD5FF;;AC+FA;EACE,0BAAA;AD5FF;;AC+FA;EACE,uBAAA;EACA,kBAAA;EACA,iBAAA;AD5FF;;ACgGA;EACE,kBAAA;AD7FF;;ACgGA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;AD7FF;;ACgGA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AD7FF;AC+FE;EACE,mBAAA;EACA,cAAA;AD7FJ;ACgGE;EACE,mBAAA;EACA,cAAA;AD9FJ;ACiGE;EACE,mBAAA;EACA,cAAA;AD/FJ;ACkGE;EACE,mBAAA;EACA,cAAA;ADhGJ;;ACoGA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qDAAA;EACA,UAAA;ADjGF;ACmGE;EACE,kCAAA;EACA,sBAAA;ADjGJ;ACoGE;EACE,eAAA;EACA,WAAA;EACA,YAAA;ADlGJ;;ACsGA,wBAAA;AAEE;EACE,aAAA;ADpGJ;ACuGE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,sBAAA;EAEA,oBAAA;ADtGJ;ACyGE;EACE,iBAAA;EACA,gBAAA;EACA,iDAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;ADvGJ;AC0GE;EACE,wBAAA;ADxGJ;;AC4GA;EACE;IACE,aAAA;IACA,0BAAA;IACA,sBAAA;EDzGF;EC2GE;IACE,aAAA;EDzGJ;EC4GE;IACE,eAAA;IACA,kBAAA;IACA,QAAA;IACA,YAAA;IACA,sBAAA;IACA,2BAAA;IACA,iBAAA;ED1GJ;EC6GE;IACE,qCAAA;IACA,SAAA;ED3GJ;EC6GI;IACE,iBAAA;ED3GN;EC8GI;IACE,sBAAA;IACA,oBAAA;ED5GN;EC+GI;IACE,sBAAA;ED7GN;ECkHA;IACE,aAAA;IACA,WAAA;IACA,sBAAA;IACA,mBAAA;IACA,6BAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,0CAAA;EDhHF;ECmHE;IACE,aAAA;IACA,sBAAA;IACA,eAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,0BAAA;IACA,YAAA;EDjHJ;ECmHI;IACE,aAAA;IACA,sBAAA;IACA,OAAA;EDjHN;ECqHM;;IAEE,qBAAA;IACA,sBAAA;IACA,kBAAA;IACA,YAAA;EDnHR;ECuHI;IACE,qBAAA;IACA,mBAAA;EDrHN;ECwHI;IACE,aAAA;EDtHN;EC0HE;IACE,aAAA;IACA,gBAAA;IACA,WAAA;IAEA,kBAAA;EDzHJ;EC2HI;IACE,WAAA;IACA,YAAA;IACA,WAAA;EDzHN;EC2HM;IACE,YAAA;IACA,aAAA;IACA,iBAAA;EDzHR;AACF;ACmIA;EACE;IACE,6BAAA;IACA,gBAAA;IACA,eAAA;EDjIF;ECoIA;IACE,sBAAA;EDlIF;ECoIE;IACE,iBAAA;EDlIJ;ECsIA;IAEE,0BAAA;EDrIF;ECuIE;IACE,qCAAA;IACA,SAAA;IACA,mCAAA;IACA,SAAA;EDrIJ;ECuII;IACE,sBAAA;IACA,oBAAA;EDrIN;AACF;AC0IA;EAEI;IACE,qCAAA;IACA,QAAA,EAAA,iCAAA;IACA,qBAAA,EAAA,mCAAA;EDzIJ;AACF;AC6IA;EAEI;IACE,0BAAA;IACA,SAAA;ED5IJ;AACF;ACgJA;EACE;IACE,4BAAA;IACA,uBAAA;IACA,4BAAA;ED9IF;ECiJA;IACE,aAAA;IACA,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;ED/IF;ECiJE;IACE,aAAA;ED/IJ;ECkJE;IACE,eAAA;IACA,kBAAA;IACA,QAAA;IACA,YAAA;IACA,sBAAA;IACA,2BAAA;IACA,iBAAA;EDhJJ;ECoJA,wFAAA;EACA;IACE,4BAAA;EDlJF;ECoJA;IACE,aAAA;IACA,WAAA;IACA,sBAAA;IACA,sBAAA;IACA,+BAAA;IACA,6BAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,0CAAA;EDlJF;ECoJE;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,WAAA;EDlJJ;ECqJE;IACE,wBAAA;IACA,uBAAA;IACA,WAAA;IACA,cAAA;EDnJJ;ECsJE;IACE,yBAAA;IACA,8BAAA;IACA,WAAA;IACA,YAAA;EDpJJ;ECsJI;IACE,yBAAA;IACA,8BAAA;IAEA,kBAAA;EDrJN;ECwJI;IACE,yBAAA;IACA,8BAAA;IACA,2BAAA;EDtJN;EC0JE;IACE,aAAA;IACA,sBAAA;IACA,eAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,yBAAA;IACA,YAAA;IACA,WAAA;EDxJJ;EC0JI;IACE,aAAA;IACA,sBAAA;IACA,OAAA;EDxJN;EC4JM;;IAEE,qBAAA;IACA,sBAAA;IACA,kBAAA;IACA,YAAA;ED1JR;EC8JI;IACE,qBAAA;IACA,mBAAA;ED5JN;EC+JI;IACE,aAAA;ED7JN;ECiKE;IACE,wBAAA;IACA,eAAA;IACA,WAAA;IACA,uBAAA;IACA,cAAA;IAEA,kBAAA;EDhKJ;ECkKI;IACE,sBAAA;IACA,uBAAA;IACA,gBAAA;IACA,wBAAA;IACA,uBAAA;EDhKN;ECkKM;IACE,uBAAA;IACA,wBAAA;IACA,iBAAA;IACA,yBAAA;IACA,8BAAA;EDhKR;ECsKA;IACE,uBAAA;IACA,4BAAA;IACA,2BAAA;IACA,gFAAA;IACA,4BAAA,EAAA,gCAAA;EDpKF;ECuKA;IACE,uBAAA;IACA,4BAAA;EDrKF;ECuKE;IACE,qBAAA,EAAA,mCAAA;IAEA,SAAA;IACA,WAAA;IASA,iDAAA;IAOA,iDAAA;IAOA,kEAAA;ED1LJ;ECqKI;IACE,sBAAA;IACA,oBAAA;IACA,2BAAA;IACA,UAAA;EDnKN;ECuKI;IACE,2BAAA;IACA,mBAAA,EAAA,sBAAA;IACA,WAAA;EDrKN;ECyKI;;IAEE,2BAAA;IACA,sBAAA;EDvKN;EC2KI;IACE,UAAA,EAAA,mDAAA;IACA,QAAA;EDzKN;EC2KM;IACE,oBAAA;IACA,gBAAA;EDzKR;EC4KM;IACE,oBAAA;IACA,gBAAA;ED1KR;EC6KM;IACE,oBAAA;ED3KR;EC6KQ;IACE,gBAAA;ED3KV;ECgLI;IACE,iBAAA;IACA,SAAA;ED9KN;AACF;ACmLA;EAEI;IACE,0BAAA;IACA,SAAA,EAAA,iCAAA;IACA,qBAAA,EAAA,mCAAA;EDlLJ;AACF;ACsLA;EACE;IACE,sBAAA;EDpLF;ECsLE;IACE,qBAAA;EDpLJ;ECuLE;IACE,eAAA;EDrLJ;ECyLA;IAEE,0BAAA;EDxLF;EC0LE;IACE,0BAAA;IACA,MAAA;IACA,mCAAA;IAEA,SAAA;IACA,WAAA;IASA,iDAAA;IAOA,iDAAA;IAOA,6CAAA;ED7MJ;ECwLI;IACE,sBAAA;IACA,oBAAA;IACA,2BAAA;IACA,UAAA;EDtLN;EC0LI;IACE,2BAAA;IACA,8BAAA;IACA,WAAA;EDxLN;EC4LI;;IAEE,2BAAA;IACA,sBAAA;ED1LN;EC8LI;IACE,wBAAA;IACA,QAAA;ED5LN;EC8LM;IACE,oBAAA;IACA,gBAAA;ED5LR;EC+LM;IACE,oBAAA;IACA,gBAAA;ED7LR;ECgMM;IACE,oBAAA;ED9LR;ECgMQ;IACE,gBAAA;ED9LV;ECqMA;IACE,eAAA;EDnMF;AACF;ACsMA,kDAAA;AACA;EACE,kBAAA;ADpMF;;ACuMA,8CAAA;AACA;;;EAGE,0BAAA;ADpMF;;ACoNA;EAmBE,mDAAA;ADnOF;ACiNE;EACE,aAAA;EACA,mBAAA;AD/MJ;ACiNI;EACE,OAAA;AD/MN;ACkNI;EACE,qCAAA;EACA,0BAAA;ADhNN;ACkNM;EACE,0BAAA;ADhNR;ACsNE;EACE;IACE,eAAA;EDpNJ;ECsNI;IACE,cAAA;IACA,YAAA;EDpNN;ECuNI;IACE,cAAA;EDrNN;AACF;;AC0NA;EACE,OAAA;ADvNF;;AC0NA;EACE,eAAA;ADvNF;;AC8NA;EACE,gBAAA;EACA,QAAA;AD3NF;;AC0OA;EACE;IACE,sBAAA;IACA,6BAAA;EDvOF;EC0OA;IACE,oCAAA;EDxOF;AACF;AC2OA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;ADzOF;AC2OE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;ADzOJ;;AC6OA,4DAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;AD1OF;AC4OE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AD1OJ;;AC8OA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AD3OF;AC6OE;EACE,OAAA;AD3OJ;;AC+OA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,mDAAA;EACA,gBAAA;EACA,MAAA,EAAA,6CAAA;EACA,UAAA;EACA,mBAAA;AD5OF;AC8OE;EACE,eAAA;AD5OJ;;ACgPA,iGAAA;AACA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;AD7OF;AC+OE;EACE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,6CAAA;AD7OJ;AC+OI;EACE,cAAA;EACA,6BAAA;AD7ON;ACgPI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AD9ON;ACkPE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;ADhPJ;ACmPE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,OAAA;EACA,YAAA;EACA,iBAAA;EACA,QAAA;EACA,YAAA;ADjPJ;ACoPE;EACE,OAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;ADlPJ;ACoPI;EACE,cAAA;ADlPN;ACsPE;EAGE,qBAAA;EACA,wCAAA;ADtPJ;ACyPE;;EAEE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,6CAAA;ADvPJ;ACyPI;;EACE,cAAA;EACA,6BAAA;ADtPN;AC0PE;;EAEE,eAAA;EACA,WAAA;EACA,YAAA;ADxPJ;;AC2PA;EACE,qBAAA;ADxPF;AC0PE;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,6BAAA;EACA,uBAAA;ADxPJ;AC2PE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,QAAA;ADzPJ;AC2PI;EACE,kBAAA;EACA,cAAA;EACA,WAAA;ADzPN;AC4PI;EACE,iDAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AD1PN;;AC+PA;EACE,0BAAA;AD5PF;;AC8PA;EAEE,eAAA;EACA,gBAAA;AD5PF;;AC+PA;EACE,eAAA;EAEA,mBAAA;AD7PF;;ACgQA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AD7PF;;ACgQA;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,yCAAA;EACA,gCAAA;EACA,wBAAA;AD7PF;AC+PE;EACE,yCAAA;AD7PJ;ACgQE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;AD9PJ;ACiQE;EACE,kBAAA;AD/PJ;ACiQI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AD/PN;ACkQI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ADhQN;;ACqQA,8CAAA;AACA;EACE,WAAA;ADlQF;;ACoQA;EACE,sBAAA;EACA,kBAAA;ADjQF;;ACoQA;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,oBAAA;ADjQF;;ACoQA,uDAAA;AAGI;EACE,oBAAA;ADnQN;;ACwQA,wBAAA;AACA;EACE,yDAAA;EACA,gBAAA;EACA,eAAA;ADrQF;;ACwQA;EACE,uCAAA;EACA;IACE,2BAAA;IACA,0CAAA;EDrQF;ECuQA;;IAEE,2BAAA;EDrQF;AACF;ACwQA;EACE,oCAAA;EAGI;IACE,sBAAA;IACA,wBAAA;IACA,2BAAA;EDxQN;EC2QI;;IAEE,sBAAA;IACA,YAAA;IACA,2BAAA;EDzQN;EC8QA,iEAAA;EAEE;IACE,kDAAA;ED7QJ;EC8QI;IACE,6BAAA;IACA,2BAAA;IACA,sBAAA;ED5QN;EC+QI;;IAEE,sBAAA;IACA,uBAAA;IACA,2BAAA;IACA,4BAAA;IACA,6BAAA;ED7QN;ECkRA,wEAAA;EACA;IACE,6BAAA;IACA,2BAAA;IACA,sBAAA;EDhRF;ECkRA;;IAEE,sBAAA;IACA,uBAAA;IACA,2BAAA;IACA,4BAAA;EDhRF;AACF;ACmRA,6CAAA;AACA;;EAEE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,uCAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,uCAAA;UAAA,+BAAA;EACA,SAAA;EACA,YAAA;ADjRF;ACmRE;;EACE,yBAAA;EACA,0BAAA;ADhRJ;;ACoRA;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;ADjRF;;ACoRA;EACE,aAAA;ADjRF;;ACoRA;EACE,iBAAA;EACA,eAAA;ADjRF;;ACoRA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;ADjRF;;ACmRA;EACE,0BAAA;ADhRF;;ACmRA,+CAAA;AACA;EACE,2BAAA;EACA,sBAAA;EACA,mDAAA;EACA,kBAAA;EACA,aAAA;ADhRF;;ACmRA;EACE,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;ADhRF;ACkRE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;ADhRJ;ACmRE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;ADjRJ;ACoRE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;ADlRJ;ACqRE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;ADnRJ;ACsRE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;ADpRJ;ACuRE;EACE,YAAA;EACA,WAAA;ADrRJ;ACwRE;EACE,YAAA;EACA,YAAA;EACA,aAAA;ADtRJ;;AC0RA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;ADvRF;ACyRE;EACE,WAAA;EACA,YAAA;ADvRJ;;AC2RA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;ADxRF;AC0RE;EACE,WAAA;EACA,YAAA;ADxRJ;;AC4RA;EACE,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;ADzRF;;AC4RA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;ADzRF;;AC4RA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;ADzRF;;AC4RA,gEAAA;AACA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;ADzRF;;AC4RA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;ADzRF;;AC4RA,+CAAA;AACA;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ADzRF;;AC4RA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,mBAAA;EACA,mBAAA;ADzRF;;AC4RA;EACE,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;ADzRF;AC2RE;EACE,YAAA;EACA,UAAA;EACA,kBAAA;ADzRJ;AC4RE;EACE,YAAA;EACA,UAAA;EACA,mBAAA;AD1RJ;AC6RE;EACE,YAAA;EACA,YAAA;AD3RJ;AC8RE;EACE,YAAA;EACA,WAAA;EACA,eAAA;AD5RJ;;ACgSA;EACE,aAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;AD7RF;;ACgSA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,cAAA;AD7RF;;ACgSA;EACE,OAAA;EACA,YAAA;AD7RF;;ACgSA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AD7RF;;ACgSA;EACE,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AD7RF;;ACgSA;EACE,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AD7RF;;ACgSA;EACE,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;AD7RF;;ACgSA;EACE;IACE,4BAAA;ED7RF;EC+RA;IACE,2BAAA;ED7RF;AACF;ACgSA,mCAAA;AACA;EACE;IACE,UAAA;IACA,mBAAA;ED9RF;ECiSA;IACE,kBAAA;IACA,YAAA;IACA,gBAAA;ED/RF;AACF;ACkSA;EACE;IACE,UAAA;IACA,mBAAA;EDhSF;ECmSA;IACE,kBAAA;IACA,YAAA;IACA,gBAAA;EDjSF;ECoSA;IACE,YAAA;EDlSF;ECoSE;IACE,YAAA;EDlSJ;ECqSE;IACE,YAAA;EDnSJ;AACF;ACuSA,oDAAA;AACA;EACE,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,6BAAA;ADrSF;;ACwSA;EACE;IACE,uBAAA;IACA,wBAAA;EDrSF;AACF;ACwSA,oEAAA;AACA;EACE,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,6BAAA;ADtSF;;ACySA,kCAAA;AACA;EACE;;IAEE,sBAAA;IACA,uBAAA;EDtSF;AACF;ACySA,8DAAA;AACA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;ADvSF;;AC0SA;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;ADvSF;;AC0SA,oEAAA;AACA;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,6BAAA;ADvSF;;AC0SA,mDAAA;AACA;EACE,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,8BAAA;EACA,sDAAA;EACA,wBAAA;EACA,2BAAA;ADvSF;;AC0SA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;ADvSF;ACySE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ADvSJ;;AC0SA;;EAEE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,yBAAA;ADvSF;;AC0SA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;ADvSF;ACySE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ADvSJ;;AC2SA,0DAAA;AACA;;EAEE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ADxSF;;AC2SA,uDAAA;AACA;;EAEE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA,EAAA,yBAAA;ADxSF;;AC0SA;EACE,qBAAA;ADvSF;;AC0SA,gFAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;ADvSF;;AC0SA,uFAAA;AACA;EACE,iBAAA;EACA,WAAA;EACA,oBAAA;ADvSF;;AC0SA,iEAAA;AACA;EACE,mEAAA;EACA;;;IAGE,2BAAA;EDvSF;EC0SA,mEAAA;EACA;IACE,6BAAA;IACA,8BAAA;IACA,sBAAA;EDxSF;EC2SA,oDAAA;EACA;IACE,6BAAA;IACA,sBAAA;IACA,2BAAA;EDzSF;EC4SA;;;;IAIE,sBAAA;IACA,uBAAA;IACA,4BAAA;IACA,2BAAA;ED1SF;AACF;AC6SA,2DAAA;AACA;EACE;IACE,kBAAA;IACA,sBAAA;IACA,oBAAA;IACA,8BAAA,EAAA,SAAA;IACA,2BAAA;ED3SF;EC6SA;;IAEE,6BAAA;IACA,MAAA;IACA,OAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;IACA,yBAAA;ED3SF;AACF;AC8SA,sCAAA;AACA;EACE,aAAA;EACA,MAAA,EAAA,oDAAA;AD5SF;;AC+SA,iFAAA;AACA;EACE;IACE,gBAAA,EAAA,6BAAA;ED5SF;AACF;AC8SA;EACE;IACE,2BAAA,EAAA,6BAAA;ED5SF;AACF;AC+SA,4CAAA;AACA;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AD7SF;;ACgTA;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,yBAAA;EACA,6BAAA;AD7SF;;ACgTA;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,yBAAA;AD7SF;;ACgTA;EACE,OAAA;EACA,YAAA;EACA,aAAA,EAAA,mBAAA;EACA,sBAAA;EACA,MAAA,EAAA,4BAAA;EACA,SAAA;EACA,UAAA;AD7SF;;ACgTA;EACE,aAAA;EACA,uBAAA;EACA,QAAA,EAAA,0CAAA;EACA,SAAA,EAAA,+BAAA;EACA,2BAAA;EACA,UAAA;EACA,8BAAA;AD7SF;;ACgTA;EACE,0BAAA;EACA,4BAAA,EAAA,kDAAA;EACA,yBAAA;EACA,oBAAA;EACA,6BAAA;EACA,2BAAA,EAAA,uCAAA;EACA,+BAAA;EACA,gCAAA,EAAA,qCAAA;EACA,wBAAA;EACA,uCAAA;EACA,2BAAA;EACA,kCAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,6BAAA,EAAA,0BAAA;EACA,gCAAA;EACA,iCAAA;EACA,8BAAA,EAAA,mBAAA;EACA,gCAAA;UAAA,wBAAA,EAAA,qCAAA;AD7SF;;ACgTA;EACE,cAAA;AD7SF;;ACgTA;EACE,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;EACA,oBAAA;EACA,2BAAA,EAAA,qCAAA;EACA,qBAAA;EACA,4BAAA;EACA,yBAAA,EAAA,wBAAA;EACA,yCAAA;EACA,6BAAA;EACA,sBAAA;AD7SF;;ACgTA,uCAAA;AACA;EACE,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;EACA,oBAAA;EACA,yBAAA;AD7SF;;ACgTA;EACE,yBAAA;AD7SF;;ACgTA,0DAAA;AACA;EACE,yBAAA;EACA,0BAAA;AD7SF;;ACgTA;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,gCAAA;AD7SF;;ACgTA;EACE,cAAA;AD7SF;;ACgTA,qEAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AD7SF;AC+SE;EACE,kBAAA;EACA,UAAA;AD7SJ;ACgTE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AD9SJ;ACiTE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AD/SJ;ACiTI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AD/SN;ACkTI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;ADhTN;ACoTE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;ADlTJ;;ACsTA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;ADnTF;;ACsTA;EACE,gBAAA;EACA,eAAA;ADnTF;ACoTE;EAAU,0BAAA;ADjTZ;;ACoTA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;ADjTF;ACkTE;EAAU,0BAAA;AD/SZ;;ACkTA,4DAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AD/SF;;ACkTA,+CAAA;AACA;EACE,eAAA;AD/SF;;ACkTA,yCAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,+BAAA;AD/SF;;ACkTA,gCAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yEAAA;EACA,uBAAA;EACA,YAAA;AD/SF;ACiTE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;AD/SJ;ACkTE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;ADhTJ;ACkTI;EACE,mBAAA;ADhTN;ACoTE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;ADlTJ;ACqTE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;ADnTJ;ACsTE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;ADpTJ;ACuTE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;ADrTJ;;ACyTA;EACE,oBAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,oCAAA;EACA,2BAAA;EACA,6BAAA;EACA,8BAAA;EACA,gCAAA;EACA,2BAAA;EACA,gCAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;ADtTF;;AC0TA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wCAAA;EACA,mBAAA;EACA,oBAAA;ADvTF;ACyTE;EACE,wCAAA;ADvTJ;AC0TE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;ADxTJ;AC0TI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;ADxTN;AC0TM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;ADxTR;AC4TQ;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AD1TV;AC6TQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AD3TV;AC6TU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AD3TZ;AC6TY;EACE,cAAA;AD3Td;AC+TU;EACE,eAAA;EACA,cAAA;AD7TZ;ACoUE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;ADlUJ;ACqUE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;ADnUJ;ACsUE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;ADpUJ;ACsUI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;ADpUN;ACuUI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;ADrUN;ACuUM;EACE,0BAAA;ADrUR;;AC2UA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;ADxUF;AC0UE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,gCAAA;EACA,mBAAA;ADxUJ;AC2UE;EACE,YAAA;EACA,UAAA;EACA,yEAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;ADzUJ;AC4UE;EACE,YAAA;EACA,WAAA;EACA,yEAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;AD1UJ;AC4UI;EACE,UAAA;AD1UN;;AC+UA;EACE;IACE,2BAAA;ED5UF;EC8UA;IACE,4BAAA;ED5UF;AACF;AC+UA,oDAAA;AACA;EA8CE,4CAAA;EAoBA,8DAAA;EAOA,uEAAA;EAgBA,wEAAA;EAsBA,gCAAA;EAqBA,oDAAA;EAaA,6FAAA;EAqEA,gEAAA;EAmFA,oCAAA;AD7mBF;ACqUE;EACE,qCAAA;EACA,cAAA;ADnUJ;ACqUI;EACE,iCAAA;EACA,cAAA;ADnUN;ACsUI;EACE,mCAAA;EACA,cAAA;ADpUN;ACuUI;EACE,oCAAA;EACA,cAAA;ADrUN;ACwUI;EACE,kCAAA;EACA,cAAA;ADtUN;AC0UE;;;;;;EAME,8BAAA;EACA,yBAAA;ADxUJ;AC2UE;;;;;EAKE,8BAAA;EACA,iDAAA;EACA,yBAAA;ADzUJ;AC6UE;EACE,oCAAA;EACA,sDAAA;AD3UJ;AC8UE;;;;;EAKE,oFAAA;EAMA,qCAAA;ADjVJ;ACqVE;EACE,8BAAA;EACA,sDAAA;EACA,yBAAA;ADnVJ;ACuVE;;;;;;EAME,oFAAA;EAMA,qCAAA;AD1VJ;AC8VE;;;;;;;;;;;;EAYE,oFAAA;EAMA,qCAAA;ADjWJ;ACqWE;;;EAGE,oFAAA;EAMA,qCAAA;ADxWJ;AC2WE;EACE,iDAAA;ADzWJ;AC4WE;EACE,sDAAA;AD1WJ;AC8WE;;;EAGE,oFAAA;EAMA,qCAAA;ADjXJ;ACqXE;EACE,kCAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;ADnXJ;ACsXE;EACE,8BAAA;ADpXJ;ACuXE;;;EAGE,8BAAA;EACA,4DAAA;ADrXJ;ACwXE;;;;;;;;;;;;;EAaE,yBAAA;ADtXJ;ACyXE;;;;;;;;;EASE,yBAAA;ADvXJ;AC0XE;;EAEE,8BAAA,EAAA,oCAAA;ADxXJ;AC2XE;;EAEE,oCAAA;ADzXJ;AC4XE;EACE,yBAAA,EAAA,wBAAA;AD1XJ;AC6XE;EACE,yBAAA,EAAA,yBAAA;AD3XJ;AC8XE;EACE,yBAAA;AD5XJ;ACgYE;EACE,yBAAA;AD9XJ;ACiYE;EACE,yBAAA,EAAA,WAAA;AD/XJ;ACkYE;;EAEE,yBAAA;ADhYJ;ACmYE;EACE,yBAAA,EAAA,+BAAA;ADjYJ;ACqYI;;EAEE,qBAAA;EACA,mBAAA;ADnYN;ACqYI;EAA8B,cAAA;ADlYlC;ACmYI;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;ADjYN;ACqYE;EAAc,cAAA;ADlYhB;ACmYE;EAAiB,cAAA;ADhYnB;ACkYE;;EAEE,oDAAA;EACA,yBAAA;ADhYJ;ACmYE;EACE;IACE,wDAAA;EDjYJ;AACF;ACoYE;EACE,kCAAA;EACA,oCAAA;ADlYJ;ACqYE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;ADnYJ;ACsYE;;;EAGE,yBAAA;ADpYJ;ACuYE;;;EAGE,8BAAA;EACA,yBAAA;ADrYJ;ACwYE;;;;EAIE,yBAAA;ADtYJ;ACyYE;EACE,kCAAA;EACA,2BAAA;ADvYJ;AC2YE;EACE,mBAAA;EACA,wEAAA;ADzYJ;AC2YI;EACE,cAAA;EACA,8CAAA;ADzYN;AC4YI;EACE,mBAAA;AD1YN;AC6YI;EACE,qBAAA;EACA,mBAAA;AD3YN;AC8YI;EACE,cAAA;AD5YN;AC+YI;EACE,cAAA;AD7YN;;ACkZA;2DAAA;AAEA;EACE,8BAAA;AD/YF;;ACkZA;EACE,qFAAA;AD/YF;;ACkZA;EACE,qFAAA;AD/YF;;ACkZA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AD/YF;;ACkZA;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,gCAAA;AD/YF;;ACkZA;EACE,0BAAA;EACA,mBAAA;AD/YF;;ACkZA;EACE,8CAAA;AD/YF;;AA/4FA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAk5FF;;AA/4FA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AAk5FF;;AA/4FA,2DAAA;AACA;EACE,oFAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;AAk5FF;;AA/4FA;EACE,sDAAA;EACA,6BAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;AAk5FF;;AA/4FA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;AAk5FF;AAh5FE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAk5FJ;;AA94FA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAi5FF;AA/4FE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAi5FJ;;AA74FA,iDAAA;AACA;EAEI;IACE,qCAAA;IACA,QAAA,EAAA,iCAAA;IACA,qBAAA,EAAA,mCAAA;EA+4FJ;EA34FA,iFAAA;EACA;IACE,gBAAA,EAAA,6BAAA;EA64FF;AACF;AA14FA;EAEI;IACE,0BAAA;IACA,SAAA,EAAA,iCAAA;IACA,qBAAA,EAAA,mCAAA;EA24FJ;AACF;AAv4FA,mEAAA;AACA;EACE;;;IAGE,2BAAA;EAy4FF;EAt4FA;IACE,2BAAA;IACA,mBAAA,EAAA,sBAAA;EAw4FF;EAr4FA;;IAEE,2BAAA;EAu4FF;EAp4FA,kEAAA;EACA;IACE,qBAAA,EAAA,mDAAA;EAs4FF;AACF;AAn4FA,wDAAA;AACA;EACE,8BAAA;EACA,gCAAA;EACA,iCAAA;EACA,gCAAA;UAAA,wBAAA;EACA,gCAAA;EACA,wBAAA;EACA,+BAAA;EACA,uCAAA;EACA,2BAAA;EACA,kCAAA;AAq4FF;;AAl4FA,wEAAA;AACA;EACE,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,sBAAA;EACA,yCAAA;AAq4FF;;AAl4FA,uCAAA;AACA;EACE,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;EACA,oBAAA;EACA,yBAAA;AAq4FF;;AAl4FA;EACE,yBAAA;EACA,0BAAA;AAq4FF;;AAl4FA;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;EACA,oBAAA;EACA,0BAAA;EACA,yBAAA;AAq4FF;;AAl4FA,qEAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAq4FF;AAn4FE;EACE,kBAAA;EACA,UAAA;AAq4FJ;AAl4FE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AAo4FJ;AAj4FE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAm4FJ;AAj4FI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AAm4FN;AAh4FI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAk4FN;AA93FE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;AAg4FJ;;AA53FA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AA+3FF;;AA53FA;EACE,gBAAA;EACA,eAAA;AA+3FF;AA93FE;EAAU,0BAAA;AAi4FZ;;AA93FA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAi4FF;AAh4FE;EAAU,0BAAA;AAm4FZ;;AAh4FA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAm4FF;;AAh4FA;EACE,eAAA;AAm4FF;;AAh4FA;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,+BAAA;AAm4FF;;AAh4FA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yEAAA;EACA,uBAAA;EACA,YAAA;AAm4FF;AAj4FE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;AAm4FJ;AAh4FE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;AAk4FJ;AAh4FI;EACE,mBAAA;AAk4FN;AA93FE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAg4FJ;AA73FE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA+3FJ;AA53FE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA83FJ;AA33FE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AA63FJ;;AAz3FA;EACE,4BAAA;EACA,yBAAA;AA43FF;;AAz3FA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AA43FF;AA13FE;EACE,mBAAA;AA43FJ;AAz3FA;EACE,YAAA;EACA,mBAAA;AA23FF;AAx3FA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,qBAAA;EACA,2CAAA;AA03FF;AAv3FA;EACE;IACE,yBAAA;EAy3FF;AACF;;AAr3FA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAw3FF;;AAr3FA;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,kCAAA;EACA,gBAAA;EACE,eAAA;EACF,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAw3FF;AAt3FE;EACE,mCAAA;AAw3FJ;;AAp3FA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAu3FF;;AAp3FA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AAu3FF;AAr3FE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAu3FJ;AAr3FI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AAu3FN;AAp3FI;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;AAs3FN;;AAj3FA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;AAo3FF;AAl3FE;EACA,aAAA;EACA,sBAAA;EACE,qBAAA;AAo3FJ;AAl3FI;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;AAo3FN;AAj3FI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AAm3FN;;AA92FA;EA0BE,gFAAA;EAuBA,oCAAA;AAk0FF;AAl3FE;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AAo3FJ;AAj3FE;EACE,gCAAA;EACA,yBAAA;AAm3FJ;AAh3FE;EACE,gDAAA;AAk3FJ;AA/2FE;;EAEE,yBAAA;AAi3FJ;AA92FE;;EAEE,yBAAA;AAg3FJ;AA52FE;;EAEE,yBAAA;AA82FJ;AA12FI;;EAEE,qBAAA;EACA,mBAAA;AA42FN;AA12FI;EAA8B,cAAA;AA62FlC;AA52FI;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AA82FN;AA12FE;EAAc,cAAA;AA62FhB;AA52FE;EAAiB,cAAA;AA+2FnB;AA52FE;EACE,mBAAA;EACA,wEAAA;AA82FJ;AA52FI;EACE,cAAA;EACA,8CAAA;AA82FN;AA32FI;EACE,mBAAA;AA62FN;AA12FI;EACE,qBAAA;EACA,mBAAA;AA42FN;AAz2FI;EACE,cAAA;AA22FN;AAx2FI;EACE,cAAA;AA02FN","sourcesContent":["@import \"../user-profile/user-profile.component\";\n\n.profile-display-name {\n  display: block;\n  width: 100%;\n  font-size: 14px;\n  color: #666666;\n  margin: 4px 0 0;\n}\n\n.profile-identity {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n/* Preserve card dimensions - ensure same as user-profile */\n.user-pro .item {\n  /* Preserve original card dimensions - width controlled by grid, height by content */\n  width: 100% !important;\n  min-width: 0 !important;\n  max-width: 100% !important;\n  min-height: auto !important;\n  height: auto !important;\n}\n\n.user-pro .item .video-thumbnail {\n  /* Preserve original card dimensions - do not change */\n  aspect-ratio: 16/9 !important;\n  width: 100% !important;\n  min-height: 0 !important;\n  max-height: none !important;\n}\n\n.video-duration {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  z-index: 2;\n\n  .duration-icon {\n    font-size: 13px;\n    width: 13px;\n    height: 13px;\n    line-height: 13px;\n  }\n}\n\n.sponsored-card-badge {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  pointer-events: none;\n\n  mat-icon {\n    font-size: 13px;\n    width: 13px;\n    height: 13px;\n    line-height: 13px;\n  }\n}\n\n/* Mobile grid layout matching search component */\n@media (max-width: 768px) {\n  .example-container {\n    .user-pro {\n      grid-template-columns: repeat(2, 1fr);\n      gap: 8px; /* Match search page mobile gap */\n      padding: 0 !important; /* Match search page - no padding */\n    }\n  }\n\n  /* Mobile-only tweak: slight left margin for video info row - match search page */\n  .video-info {\n    margin-left: 5px; /* Match search page mobile */\n  }\n}\n\n@media (max-width: 480px) {\n  .example-container {\n    .user-pro {\n      grid-template-columns: 1fr;\n      gap: 16px; /* Match search page mobile gap */\n      padding: 0 !important; /* Match search page - no padding */\n    }\n  }\n}\n\n/* Mobile: full-width with square edges matching search component */\n@media (max-width: 767px) {\n  .user-pro .item,\n  .user-pro .item .video-thumbnail,\n  .video-thumbnail {\n    border-radius: 0 !important;\n  }\n\n  .user-pro .item > div:first-child {\n    border-radius: 0 !important;\n    margin-bottom: 12px; /* Match search page */\n  }\n\n  .thumbnail-image,\n  .thumbnail-video {\n    border-radius: 0 !important;\n  }\n\n  /* Card content - match search page (no padding on card content) */\n  .user-pro .item > div:last-child {\n    padding: 0 !important; /* Match search page - no padding on card content */\n  }\n}\n\n/* Ensure flow title wraps to next line if not fitting */\n.video-title {\n  white-space: normal !important;\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n  hyphens: auto !important;\n  -webkit-line-clamp: 2 !important;\n  line-clamp: 2 !important;\n  display: -webkit-box !important;\n  -webkit-box-orient: vertical !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n/* Ensure profile image and username are on same line like search page */\n.channel-meta-row {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  flex-wrap: nowrap !important;\n  width: 100% !important;\n  justify-content: space-between !important;\n}\n\n/* Group avatar and username together */\n.channel-info {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  cursor: pointer !important;\n  margin: 0 !important;\n  flex-shrink: 0 !important;\n}\n\n.channel-info .video-avatar {\n  flex-shrink: 0 !important;\n  margin-right: 0 !important;\n}\n\n.channel-info .channel-name {\n  white-space: nowrap !important;\n  flex-shrink: 0 !important;\n  display: inline-block !important;\n  margin: 0 !important;\n  font-size: 13px !important;\n  color: #606060 !important;\n}\n\n/* YouTube-style collab: overlapping avatars + \"name and @coauthor\" */\n.avatar-stack {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n\n  .video-avatar {\n    position: relative;\n    z-index: 1;\n  }\n\n  .collab-avatar-overlap {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-left: -7px;\n    border: 2px solid #fff;\n    z-index: 2;\n    position: relative;\n    flex-shrink: 0;\n  }\n\n  .collab-avatar-extra {\n    position: relative;\n    width: 20px;\n    height: 20px;\n    margin-left: -7px;\n    z-index: 3;\n    flex-shrink: 0;\n    cursor: pointer;\n\n    .collab-extra-img {\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      object-fit: cover;\n      border: 2px solid #fff;\n      display: block;\n    }\n\n    .collab-extra-badge {\n      position: absolute;\n      bottom: -3px;\n      right: -4px;\n      background: #3b82f6;\n      color: #fff;\n      font-size: 7px;\n      font-weight: 700;\n      border-radius: 8px;\n      padding: 1px 3px;\n      line-height: 1.2;\n      white-space: nowrap;\n    }\n  }\n\n  .collab-avatar-overlap-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    margin-left: -7px;\n    color: #bbb;\n    z-index: 2;\n    position: relative;\n    flex-shrink: 0;\n    background: #f0f0f0;\n    border-radius: 50%;\n    border: 2px solid #fff;\n    line-height: 20px;\n  }\n}\n\n.collab-sep {\n  color: #888;\n  font-weight: 400;\n  font-size: 11px;\n}\n\n.collab-coname {\n  font-weight: 500;\n  cursor: pointer;\n  &:hover { text-decoration: underline; }\n}\n\n.collab-extra-count-text {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n  &:hover { text-decoration: underline; }\n}\n\n.avatar-stack-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.collab-stack-clickable {\n  cursor: pointer;\n}\n\n.collab-popup-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 499;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.collab-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 500;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22), 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px 16px 14px;\n  width: 300px;\n\n  .collab-popup-title {\n    font-size: 11px;\n    font-weight: 700;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #f3f4f6;\n    margin-bottom: 10px;\n    text-align: center;\n  }\n\n  .collab-popup-card {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 10px 10px;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 0.15s;\n\n    &:hover {\n      background: #f5f7fa;\n    }\n  }\n\n  .collab-popup-avatar-wrap {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n    border: 2px solid #e5e7eb;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f3f4f6;\n  }\n\n  .collab-popup-pic {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n  }\n\n  .collab-popup-icon {\n    font-size: 34px;\n    width: 34px;\n    height: 34px;\n    color: #9ca3af;\n    line-height: 1;\n  }\n\n  .collab-popup-uname {\n    font-size: 13px;\n    font-weight: 600;\n    color: #1a1a2e;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n  }\n}\n\n.video-views {\n  margin-left: auto !important;\n  flex-shrink: 0 !important;\n}\n\n.primary-btn {\n  background: #5ea1d8;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 16px;\n  font-family: \"Raleway\", sans-serif;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n\n  &:hover {\n    background: #4a8fc4;\n}\n\n.primary-btn:disabled {\n  opacity: 0.8;\n  cursor: not-allowed;\n}\n\n.btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  animation: follow-spin 0.7s linear infinite;\n}\n\n@keyframes follow-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n}\n\n.primary-btn.following {\n  background: #f0f0f0;\n  color: #5ea1d8;\n  border: 1px solid #5ea1d8;\n}\n\n.secondary-btn {\n  background: transparent;\n  border: 1px solid #5ea1d8;\n  border-radius: 6px;\n  color: #5ea1d8;\n  padding: 8px 16px;\n  font-family: \"Raleway\", sans-serif;\n  font-weight: 600;\n    cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n\n  &:hover {\n    background: rgba(94, 161, 216, 0.1);\n  }\n}\n\n.actions-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.profile-stats {\n  display: flex;\n  gap: 24px;\n  margin-top: 20px;\n  flex-wrap: wrap;\n\n  .stat {\n    display: flex;\n    flex-direction: column;\n    min-width: 100px;\n\n    .stat-number {\n      font-size: 18px;\n      font-weight: 700;\n      color: #212427 !important;\n    }\n\n    .stat-label {\n      font-size: 12px;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      color: #606060 !important;\n    }\n  }\n}\n\n.profile-stat-bar {\n  display: flex;\n  justify-content: flex-end;\n  gap: 24px;\n  padding: 16px 0;\n\n  .profile-stat-item {\n  display: flex;\n  flex-direction: column;\n    align-items: flex-end;\n\n    .label {\n      font-size: 12px;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      color: #606060 !important;\n    }\n\n    .value {\n      font-size: 18px;\n      font-weight: 700;\n      color: #212427 !important;\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .primary-btn.following {\n    background: #1f2937 !important;\n    color: #93c5fd !important;\n    border-color: #5ea1d8 !important;\n  }\n\n  .secondary-btn {\n    border-color: #93c5fd !important;\n    color: #93c5fd !important;\n  }\n\n  .secondary-btn:hover {\n    background: rgba(147, 197, 253, 0.12) !important;\n  }\n\n  .profile-stats .stat .stat-number,\n  .profile-stat-bar .profile-stat-item .value {\n    color: #ffffff !important;\n  }\n\n  .profile-stats .stat .stat-label,\n  .profile-stat-bar .profile-stat-item .label {\n    color: #cbd5e1 !important;\n  }\n\n  /* Outrank .channel-info .channel-name light color so grid matches search page */\n  .channel-info .channel-name,\n  .user-pro .channel-name {\n    color: #9ca3af !important;\n  }\n\n  .avatar-stack {\n    .collab-avatar-overlap,\n    .collab-avatar-overlap-icon {\n      border-color: #1f2937;\n      background: #374151;\n    }\n    .collab-avatar-overlap-icon { color: #6b7280; }\n    .collab-avatar-extra {\n      border-color: #1f2937;\n      background: #374151;\n      color: #d1d5db;\n    }\n  }\n\n  .collab-sep { color: #6b7280; }\n  .collab-coname { color: #9ca3af; }\n\n  /* Collaborators popup — dark mode */\n  .collab-popup {\n    background: #1f2937;\n    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.6), 0 2px 10px rgba(0, 0, 0, 0.4);\n\n    .collab-popup-title {\n      color: #64748b;\n      border-bottom-color: rgba(148, 163, 184, 0.15);\n    }\n\n    .collab-popup-card:hover {\n      background: #374151;\n    }\n\n    .collab-popup-avatar-wrap {\n      border-color: #374151;\n      background: #111827;\n    }\n\n    .collab-popup-icon {\n      color: #6b7280;\n    }\n\n    .collab-popup-uname {\n      color: #e2e8f0;\n    }\n  }\n}\n",".row {\n  // margin-top: 10px;\n\n  /* Prevent Bootstrap clearfix from creating blank box */\n  &::before,\n  &::after {\n    display: none !important;\n    content: none !important;\n  }\n\n  /* Override display: table that might be applied by Bootstrap */\n  display: block !important;\n\n  /* When inside .user-pro, use contents display */\n  .user-pro & {\n    display: contents !important;\n  }\n}\n\nbody {\n  overflow-y: hidden !important;\n}\n\n@media (max-width: 767px) {\n  body {\n    overflow-y: auto !important;\n  }\n}\n\n.textcolor {\n  color: #5ea1d8;\n  color: #000;\n  position: relative;\n  text-decoration: none;\n}\n\n.menunav {\n  width: 35px;\n  height: 5px;\n  background-color: white;\n  margin: 6px 0;\n}\n\n.item {\n  // height: 220px !important;\n  // background-color: lightgray;\n  // border: solid 0.5px lightgrey;\n  // margin-left: 32px;\n  margin-top: 20px;\n  // width: 170px;\n  position: relative;\n  /* Preserve original card dimensions - width controlled by grid, height by content */\n  width: 100% !important;\n  min-width: 0 !important;\n  max-width: 100% !important;\n\n  .rating-badge {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    background-color: rgba(0, 0, 0, 0.7);\n    color: white;\n    padding: 4px 8px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 12px;\n    font-weight: 500;\n    z-index: 10;\n  }\n}\n\n.item .img {\n  height: 150px !important;\n  background-color: lightgray;\n\n  // margin: 5px;\n}\n\np {\n  margin: 0px;\n}\n\n.zoom {\n  cursor: pointer;\n  width: 100%;\n  height: 70%;\n  transition: transform 0.1s;\n  /* Animation */\n}\n\n.zoom:hover {\n  border-radius: 5px;\n  // -ms-transform: scale(1.2); /* IE 9 */\n  // -webkit-transform: scale(1.5); /* Safari 3-8 */\n  transform: scale(1.1);\n  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */\n}\n\n.owl-carousel .owl-nav button.owl-next,\n.owl-carousel .owl-nav button.owl-prev,\n.owl-carousel button.owl-dot {\n  font-size: 55px !important;\n}\n\n.owl-theme .owl-nav [class*=\"owl-\"] {\n  font-size: 55px !important;\n  color: black;\n}\n\nbutton span {\n  font-size: 55px;\n  color: black;\n}\n\n.owl-nav {\n  display: none;\n}\n\n.with-icon {\n  display: flex;\n  align-items: center;\n}\n\n.mat-badge-content {\n  background-color: #5ea1d8;\n  color: white;\n}\n\n.mat-badge-content {\n  background: #5ea1d8;\n  color: #fff !important;\n}\n\n.div1 {\n  height: auto;\n  min-height: 70px;\n  padding-bottom: 10px;\n  //border: 1px solid blue;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: white;\n  overflow: visible;\n  z-index: 1;\n}\n\n.div .with-icon[_ngcontent-elp-c267] {\n  display: flex;\n  align-items: center;\n  color: black;\n}\n\n.with-icon[_ngcontent-xah-c268] {\n  color: black;\n}\n\n.item {\n  color: black;\n}\n\n.mat-mdc-tab-group.mat-primary .mat-ink-bar,\n.mat-mdc-tab-nav-bar.mat-primary .mat-ink-bar {\n  color: #5ea1d8;\n  background-color: #5ea1d8;\n}\n\n.notify {\n  color: grey;\n}\n\n.notify:hover {\n  color: #5ea1d8;\n}\n\n.notify:active {\n  color: #5ea1d8;\n}\n\n.notify:focus {\n  color: #5ea1d8;\n}\n\n.mat-tab-body-content {\n  height: unset !important;\n  \n  .item {\n    margin-top: 5px;\n  }\n}\n\n/*new added apart from user view profile*/\n.gridgroup-wrap {\n  max-width: 100%;\n  flex: 1;\n  height: calc(100vh - 56px); /* full viewport minus fixed header */\n  overflow-y: auto; /* scroll only right content; keep tabs sticky */\n  padding-left: 0 !important; /* remove unintended left padding */\n\n  /* Keep Angular Material tab header fixed while content scrolls */\n  .mat-mdc-tab-header,\n  .mat-mdc-tab-group .mat-mdc-tab-header {\n    position: sticky;\n    top: 0; /* sticky relative to the scrollable right pane */\n    z-index: 7;\n    background: #ffffff;\n  }\n\n  br {\n    display: none;\n  }\n\n  .mat-grid-list {\n    display: none;\n  }\n\n  .textcolor {\n    padding: 5px 10px;\n    background: #fff;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    font-family: \"Raleway\";\n    font-weight: 500;\n    cursor: pointer;\n    font-size: 17px;\n    color: #000;\n  }\n\n  .mat-tab-label {\n    font-family: \"Raleway\";\n    font-weight: 500;\n    cursor: pointer;\n    font-size: 17px;\n    color: #5ea1d8;\n  }\n}\n\n/*new added apart from user view profile end*/\n\n.example-container {\n  display: flex;\n  min-width: auto !important;\n  padding: 0; /* header offset handled globally */\n  height: calc(100vh - 56px); /* ensure columns share same viewport height */\n  align-items: stretch; /* make children equal height */\n  // overflow-y: scroll !important;\n  position: relative;\n\n  .disnone {\n    display: none;\n  }\n\n  .userico {\n    // max-width: 400px;\n    width: 100%;\n    position: sticky;\n    top: 56px; /* stay under fixed header */\n    height: calc(100vh - 56px);\n    margin: 0px !important;\n    box-shadow: none !important;\n    overflow: hidden;\n    background: #fff;\n    overflow-y: auto;\n\n    &::-webkit-scrollbar {\n      width: 4px;\n      height: 100px;\n    }\n\n    &::-webkit-scrollbar-track {\n      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: #5ea1d8;\n      outline: 1px solid #5ea1d8;\n    }\n  }\n\n  .user-pro {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n    padding: 0;\n    width: 100%;\n\n    .row {\n      display: contents; /* Let grid handle layout */\n\n      /* Override Bootstrap clearfix that creates blank box */\n      &::before,\n      &::after {\n        display: none !important;\n        content: none !important;\n      }\n    }\n\n    .item {\n      background-color: transparent;\n      border-radius: 12px;\n      overflow: visible;\n      transition: transform 0.2s;\n      cursor: pointer;\n      display: flex;\n      flex-direction: column;\n      margin: 0 !important;\n      width: 100% !important;\n      border: none !important;\n      box-shadow: none !important;\n      /* Preserve original card dimensions - maintain existing size */\n      min-height: auto !important;\n      height: auto !important;\n    }\n\n    /* Desktop: align spacing to search page */\n    @media (min-width: 992px) {\n      padding-bottom: 24px; /* Add space before blog listing and ensure tab indicator is visible */\n\n      .row {\n        margin-top: 0 !important;\n        margin-left: 0 !important;\n        margin-right: 0 !important;\n        display: contents !important; /* Ensure contents display on desktop */\n\n        /* Override Bootstrap clearfix that creates blank box */\n        &::before,\n        &::after {\n          display: none !important;\n          content: none !important;\n        }\n      }\n\n      .item {\n        margin: 0 !important;\n        padding: 0 !important;\n      }\n\n      .video-thumbnail {\n        margin-bottom: 12px;\n      }\n    }\n\n    .item:hover {\n      transform: translateY(-2px);\n    }\n\n    /* Thumbnail wrapper matching search page */\n    .item > div:first-child {\n      position: relative;\n      width: 100% !important;\n      aspect-ratio: 16/9 !important;\n      background-color: #f5f5f5;\n      border-radius: 12px;\n      overflow: hidden;\n      margin-bottom: 12px;\n      cursor: pointer;\n    }\n\n    /* Remove any inner margins from direct children */\n    .item > div {\n      margin: 0px 0px 5px 0px !important;\n      padding: 0 !important;\n    }\n\n    /* Search-like thumbnail styling - ensure consistent 16:9 aspect ratio */\n    .item .img-display,\n    .item .video-display {\n      width: 100% !important;\n      height: 100% !important;\n      object-fit: cover !important;\n      background-color: #f5f5f5;\n      border-radius: 12px;\n      display: block;\n      padding: 0 !important;\n      margin: 0 !important;\n    }\n\n    /* Video info section matching search page */\n    .item > div:last-child {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      padding: 0;\n      flex: 1 0 auto;\n      position: relative;\n\n      /* Title first */\n      p.lf13 {\n        order: 1;\n        margin: 0;\n      }\n\n      /* Unique ID second */\n      p:not(.lf13):not(.with-icon p) {\n        order: 2;\n        margin: 0;\n      }\n\n      /* Avatar and username third */\n      .with-icon {\n        order: 3;\n        margin: 0;\n      }\n    }\n\n    /* Restructure to video-info style */\n    .item > div:last-child {\n      .with-icon {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n      }\n    }\n\n    .item p.lf13 {\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 1.3;\n      margin: 0;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      color: #000000;\n      cursor: pointer;\n    }\n\n    .item .with-icon {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      margin-top: 4px;\n\n      img {\n        width: 36px !important;\n        height: 36px !important;\n        border-radius: 50%;\n        object-fit: cover;\n        flex-shrink: 0;\n      }\n\n      p {\n        font-size: 13px;\n        color: #606060;\n        margin: 0;\n        line-height: 1.2;\n        cursor: pointer;\n      }\n    }\n\n    /* Price badge matching search page - positioned on thumbnail */\n    .item > div:first-child {\n      position: relative;\n    }\n\n    .item .priceIcon-p {\n      position: absolute;\n      top: 8px;\n      right: 8px;\n      z-index: 10;\n      background-color: rgba(33, 36, 39, 0.5);\n      color: #ffffff;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 1;\n      padding: 6px 10px;\n      border-radius: 6px;\n      backdrop-filter: saturate(120%);\n      margin: 0;\n      border: none;\n\n      mat-label {\n        color: #ffffff !important;\n      }\n    }\n\n    /* Unique ID styling */\n    .item p:not(.lf13):not(.with-icon p) {\n      font-size: 12px;\n      color: #606060;\n      margin: 0;\n      line-height: 1.2;\n    }\n  }\n}\n\n/* Desktop: show profile (left panel) at the top, like mobile/tablet */\n@media (min-width: 993px) {\n  .example-container {\n    display: block !important; /* stack children */\n    flex-direction: column !important;\n    height: auto !important; /* allow natural stacking height */\n    align-items: initial !important;\n  }\n\n  .example-container .userico {\n    position: relative !important;\n    top: 0 !important;\n    height: auto !important;\n    overflow: initial !important;\n    width: 100% !important;\n  }\n\n  .gridgroup-wrap {\n    height: auto !important;\n    overflow: visible !important;\n    width: 100% !important;\n    margin: 0 !important;\n    padding: 24px !important; /* Match search page padding */\n  }\n\n  .vp-wrapper {\n    border-right: 0 !important;\n    border-bottom: 2px solid lightgrey !important;\n    height: auto !important; /* shrink to content to avoid empty right area */\n    padding-left: 0 !important; /* override inline left padding */\n\n    margin: 0 auto; /* center the profile block */\n    padding-right: 24px;\n  }\n\n  /* Center inner content and constrain width */\n  .vp-wrapper .vp-userdetails,\n  .vp-wrapper .mat-mdc-card-header {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n\n  /* Remove any unintended horizontal gaps */\n  .userico {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  /* Make profile text/buttons readable over white background */\n  .vp-wrapper .vp-userdetails {\n    color: #212427 !important;\n  }\n  .vp-wrapper .vp-userdetails span {\n    color: #212427 !important;\n  }\n  .vp-wrapper .vp-userdetails a {\n    color: #5ea1d8 !important;\n  }\n  .vp-wrapper .vp-userdetails .button-wrap a {\n    display: inline-block !important;\n    width: auto !important;\n    padding: 8px 14px !important;\n    margin-right: 12px;\n  }\n}\n\n.vp-wrapper {\n  display: flex;\n  width: 100%;\n  font-family: \"Raleway\";\n  flex-direction: column;\n  padding: 0.5rem 3rem;\n  border-radius: 0px;\n  box-shadow: none;\n  margin-left: 0px;\n  height: 100%;\n  border-right: 2px solid lightgrey !important;\n  z-index: 3;\n  background: transparent;\n\n  .material-icons {\n    font-size: 200px !important;\n  }\n\n  .vp-userdetails {\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 20px;\n    padding: 20px 0px 0px;\n    height: 100%;\n    color: #212427;\n\n    .vp-usertext {\n      display: flex;\n      flex-direction: column;\n      flex: 1;\n    }\n\n    .button-wrap {\n      p,\n      a {\n        display: block;\n        color: #fff !important;\n        padding: 10px;\n        background: #5ea1d8 !important;\n        text-align: center;\n        font-weight: 500;\n        border-radius: 5px;\n        text-decoration: none;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 33px;\n      }\n    }\n\n    span {\n      word-break: break-all;\n      margin-bottom: 10px;\n    }\n\n    a {\n      // text-decoration: underline;\n      margin-bottom: 10px;\n      cursor: pointer;\n      color: #5ea1d8 !important;\n    }\n\n    br {\n      display: none;\n    }\n  }\n\n  .mat-mdc-card-header {\n    display: flex;\n    max-width: 300px;\n    width: 100%;\n\n    text-align: center;\n    margin: 0px auto;\n\n    .mat-mdc-card-avatar {\n      width: auto;\n      height: auto;\n      width: 100%;\n\n      img {\n        width: 200px;\n        height: 200px;\n        object-fit: cover;\n      }\n    }\n  }\n}\n\n/* Profile hero overlay layout */\n.profile-hero {\n  position: relative;\n  display: block;\n}\n.profile-hero .profile-avatar {\n  z-index: 1;\n}\n.profile-hero .profile-overlay {\n  position: static;\n}\n\n@media (min-width: 993px) {\n  .profile-hero {\n    min-height: 140px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n  .profile-hero .profile-avatar {\n    position: relative;\n    flex: 0 0 auto;\n  }\n  .profile-hero .profile-overlay {\n    position: static;\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n  .profile-hero .example-header-image img,\n  .profile-hero .example-header-image .material-icons {\n    width: 120px !important;\n    height: 120px !important;\n  }\n}\n\n/* Banner */\n.profile-banner {\n  width: 100%;\n  height: 180px;\n  background: linear-gradient(90deg, #f7f7f7, #eaeaea);\n}\n\n/* Header row: name + actions */\n.profile-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.plan-label-chip {\n  border: 1px solid rgba(94, 161, 216, 0.35);\n  background: rgba(94, 161, 216, 0.12);\n  color: #1d4f7a;\n  border-radius: 999px;\n  padding: 0.2rem 0.7rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  cursor: pointer;\n  line-height: 1.4;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: rgba(94, 161, 216, 0.2);\n    border-color: #5ea1d8;\n  }\n}\n\n.profile-stats {\n  display: flex;\n  gap: 24px;\n  margin-top: 20px;\n  flex-wrap: wrap;\n\n  .stat {\n    display: flex;\n    flex-direction: column;\n    min-width: 100px;\n\n    .stat-number {\n      font-size: 18px;\n      font-weight: 700;\n      color: #212427 !important;\n    }\n\n    .stat-label {\n      font-size: 12px;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      color: #606060 !important;\n    }\n  }\n}\n\n.profile-stat-bar {\n  display: flex;\n  justify-content: flex-end;\n  gap: 24px;\n  padding: 16px 0;\n\n  .profile-stat-item {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n\n    .label {\n      font-size: 12px;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      color: #606060 !important;\n    }\n\n    .value {\n      font-size: 18px;\n      font-weight: 700;\n      color: #212427 !important;\n    }\n  }\n}\n.profile-header-row .actions-row a {\n  display: inline-block;\n  padding: 8px 14px;\n  border-radius: 6px;\n}\n\n/* Mobile: Ensure buttons are well aligned */\n@media (max-width: 992px) {\n  .profile-header-row .actions-row {\n    align-items: center;\n    \n    a {\n      margin-top: 0 !important;\n      vertical-align: middle;\n      display: inline-flex;\n      align-items: center;\n    }\n  }\n}\n\n/* Mobile and tablet: allow wrapping for long usernames */\n@media (max-width: 992px) {\n  .profile-header-row {\n    flex-wrap: wrap;\n    align-items: flex-start;\n  }\n\n  .tagparent {\n    flex: 1 1 100%;\n    min-width: 0;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n\n    .profile-title-row {\n      flex: 1 1 auto;\n      min-width: 0;\n\n      h2 {\n        word-break: break-word;\n        overflow-wrap: break-word;\n      }\n    }\n\n    > span {\n      flex-shrink: 0;\n      margin-left: 0 !important;\n    }\n  }\n\n  .actions-row {\n    flex: 1 1 100%;\n    margin-top: 8px;\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n    align-items: center;\n    \n    a {\n      margin-top: 0 !important;\n      display: inline-flex;\n      align-items: center;\n      vertical-align: middle;\n    }\n  }\n}\n\n/* Tabs styling */\n.tabs-container .mat-tab-label {\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.mat-mdc-tab-group.mat-primary .mat-ink-bar,\n.mat-mdc-tab-nav-bar.mat-primary .mat-ink-bar {\n  height: 2px;\n}\n\nh2 {\n  font-size: 26px !important;\n}\n\nh3 {\n  font-size: 20px !important;\n}\n\n.flowdraft-wrap {\n  padding: 0rem 0rem 2rem;\n  overflow-y: scroll;\n  margin-left: 10px;\n  // height: 800px;\n}\n\n.draft-flow-card {\n  position: relative;\n}\n\n.content-status-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 4px 0 6px;\n}\n\n.content-status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 18px;\n  white-space: nowrap;\n  background: #f2f4f7;\n  color: #344054;\n\n  &[data-state=\"in-review\"] {\n    background: #fff4e5;\n    color: #b54708;\n  }\n\n  &[data-state=\"rejected\"] {\n    background: #fdecec;\n    color: #b42318;\n  }\n\n  &[data-state=\"approved\"] {\n    background: #e8f7ee;\n    color: #067647;\n  }\n\n  &[data-state=\"pack\"] {\n    background: #eef4ff;\n    color: #3538cd;\n  }\n}\n\n.draft-flow-delete-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 12;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(0, 0, 0, 0.65);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n  padding: 0;\n\n  &:hover {\n    background: rgba(198, 40, 40, 0.9);\n    transform: scale(1.05);\n  }\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n/*followerd added right*/\n.addrgt {\n  .mat-mdc-grid-tile:first-child {\n    display: none;\n  }\n\n  .mat-mdc-grid-tile {\n    display: block;\n    position: absolute;\n    overflow: hidden;\n    max-width: 100% !important;\n    width: 100% !important;\n    // background: yellow;\n    left: 0px !important;\n  }\n\n  .textcolor {\n    padding: 5px 10px;\n    background: #fff;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    font-family: \"Raleway\";\n    font-weight: 500;\n    cursor: pointer;\n    font-size: 17px;\n    color: #000;\n    border-radius: 5px;\n  }\n\n  .mat-mdc-figure div {\n    display: flex !important;\n  }\n}\n\n@media only screen and (max-width: 1200px) and (min-width: 768px) {\n  .example-container {\n    display: flex;\n    min-width: auto !important;\n    flex-direction: column;\n\n    .disnone {\n      display: none;\n    }\n\n    .userico {\n      max-width: 100%;\n      position: relative;\n      top: 0px;\n      height: auto;\n      margin: 0px !important;\n      box-shadow: none !important;\n      overflow: initial;\n    }\n\n    .user-pro {\n      grid-template-columns: repeat(4, 1fr);\n      gap: 16px;\n\n      .row {\n        display: contents;\n      }\n\n      .item {\n        width: 100% !important;\n        margin: 0 !important;\n      }\n\n      .with-icon.ng-star-inserted {\n        width: 100% !important;\n      }\n    }\n  }\n\n  .vp-wrapper {\n    display: flex;\n    width: 100%;\n    font-family: \"Raleway\";\n    flex-direction: row;\n    padding: 2rem 3rem !important;\n    border-radius: 0px;\n    box-shadow: none;\n    margin-left: 0px;\n    height: 100%;\n    border-right: 0px solid #5ea1d8 !important;\n    //    border-bottom: 1px solid lightgrey;\n\n    .vp-userdetails {\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      font-size: 15px;\n      font-weight: 500;\n      line-height: 20px;\n      padding: 20px 0px 0px 20px;\n      height: 100%;\n\n      .vp-usertext {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n      }\n\n      .button-wrap {\n        p,\n        a {\n          display: inline-block;\n          color: #fff !important;\n          padding: 10px 20px;\n          height: auto;\n        }\n      }\n\n      span {\n        word-break: break-all;\n        margin-bottom: 10px;\n      }\n\n      br {\n        display: none;\n      }\n    }\n\n    .mat-mdc-card-header {\n      display: flex;\n      max-width: 200px;\n      width: 100%;\n\n      text-align: center;\n\n      .mat-mdc-card-avatar {\n        width: auto;\n        height: auto;\n        width: 100%;\n\n        img {\n          width: 200px;\n          height: 200px;\n          object-fit: cover;\n        }\n      }\n    }\n  }\n\n  // .mat-sidenav-content{\n  //   padding:0px 15px !important;\n  // }\n}\n\n@media (max-width: 992px) {\n  .vp-wrapper {\n    padding: 2rem 15px !important;\n    margin-left: 0px;\n    flex-wrap: wrap;\n  }\n\n  .flowdraft-wrap {\n    padding: 0rem 0px 2rem;\n\n    .mat-mdc-tab-body-wrapper {\n      padding: 0px 15px;\n    }\n  }\n\n  .example-container {\n    // overflow:scroll !important;\n    height: inherit !important;\n\n    .user-pro {\n      grid-template-columns: repeat(2, 1fr);\n      gap: 12px;\n      padding: 0px 5px 0px 0px !important;\n      margin: 0;\n\n      .item {\n        width: 100% !important;\n        margin: 0 !important;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .example-container {\n    .user-pro {\n      grid-template-columns: repeat(2, 1fr);\n      gap: 8px; /* Match search page mobile gap */\n      padding: 0 !important; /* Remove padding to match search */\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .example-container {\n    .user-pro {\n      grid-template-columns: 1fr;\n      gap: 16px;\n    }\n  }\n}\n\n@media (max-width: 767px) {\n  mat-sidenav-content.example-container {\n    overflow: visible !important;\n    height: auto !important;\n    min-height: 100vh !important;\n  }\n\n  .example-container {\n    display: flex;\n    min-width: auto !important;\n    flex-direction: column;\n    height: auto !important;\n    overflow: visible !important;\n\n    .disnone {\n      display: none;\n    }\n\n    .userico {\n      max-width: 100%;\n      position: relative;\n      top: 0px;\n      height: auto;\n      margin: 0px !important;\n      box-shadow: none !important;\n      overflow: visible;\n    }\n  }\n\n  /* Remove padding-bottom for mat-mdc-card-content:last-child on mobile for userprofile */\n  mat-mdc-card-content:last-child {\n    padding-bottom: 0 !important;\n  }\n  .vp-wrapper {\n    display: flex;\n    width: 100%;\n    font-family: \"Raleway\";\n    flex-direction: column;\n    padding: 0.5rem 15px !important;\n    padding-left: 15px !important;\n    border-radius: 0px;\n    box-shadow: none;\n    margin-left: 0px;\n    height: auto;\n    border-right: 0px solid #5ea1d8 !important;\n\n    .profile-hero {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      width: 100%;\n    }\n\n    .profile-avatar {\n      display: flex !important;\n      justify-content: center;\n      width: 100%;\n      margin: 0 auto;\n    }\n\n    .example-header-image {\n      display: block !important;\n      visibility: visible !important;\n      width: auto;\n      height: auto;\n\n      img {\n        display: block !important;\n        visibility: visible !important;\n\n        border-radius: 50%;\n      }\n\n      .material-icons {\n        display: block !important;\n        visibility: visible !important;\n        font-size: 120px !important;\n      }\n    }\n\n    .vp-userdetails {\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      font-size: 15px;\n      font-weight: 500;\n      line-height: 20px;\n      padding: 20px 0px 0px 0px;\n      height: auto;\n      width: 100%;\n\n      .vp-usertext {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n      }\n\n      .button-wrap {\n        p,\n        a {\n          display: inline-block;\n          color: #fff !important;\n          padding: 10px 20px;\n          height: auto;\n        }\n      }\n\n      span {\n        word-break: break-all;\n        margin-bottom: 10px;\n      }\n\n      br {\n        display: none;\n      }\n    }\n\n    .mat-mdc-card-header {\n      display: flex !important;\n      max-width: 100%;\n      width: 100%;\n      justify-content: center;\n      margin: 0 auto;\n\n      text-align: center;\n\n      .mat-mdc-card-avatar {\n        width: auto !important;\n        height: auto !important;\n        max-width: 200px;\n        display: flex !important;\n        justify-content: center;\n\n        img {\n          width: 120px !important;\n          height: 120px !important;\n          object-fit: cover;\n          display: block !important;\n          visibility: visible !important;\n        }\n      }\n    }\n  }\n\n  .gridgroup-wrap {\n    height: auto !important;\n    overflow: visible !important;\n    max-height: none !important;\n    /* Mobile: let media run edge-to-edge like search page (no horizontal padding) */\n    padding: 0 0 60px !important; /* only space above bottom nav */\n  }\n\n  .example-container {\n    height: auto !important;\n    overflow: visible !important;\n\n    .user-pro {\n      padding: 0 !important; /* Match search page - no padding */\n\n      margin: 0;\n      width: 100%;\n\n      .item {\n        width: 100% !important;\n        margin: 0 !important;\n        border-radius: 0 !important;\n        padding: 0;\n      }\n\n      /* Thumbnail wrapper - full width, square edges */\n      .item > div:first-child {\n        border-radius: 0 !important;\n        margin-bottom: 12px; /* Match search page */\n        width: 100%;\n      }\n\n      /* Images and videos - full width, square edges */\n      .item .img-display,\n      .item .video-display {\n        border-radius: 0 !important;\n        width: 100% !important;\n      }\n\n      /* Card content - match search page (no padding on card content) */\n      .item > div:last-child {\n        padding: 0; /* Match search page - no padding on card content */\n        gap: 4px;\n\n        p.lf13 {\n          margin: 0 !important;\n          line-height: 1.3;\n        }\n\n        p:not(.lf13):not(.with-icon p) {\n          margin: 0 !important;\n          line-height: 1.2;\n        }\n\n        .with-icon {\n          margin: 0 !important;\n\n          p {\n            line-height: 1.2;\n          }\n        }\n      }\n\n      .row {\n        padding-bottom: 0;\n        margin: 0;\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .example-container {\n    .user-pro {\n      grid-template-columns: 1fr;\n      gap: 16px; /* Match search page mobile gap */\n      padding: 0 !important; /* Match search page - no padding */\n    }\n  }\n}\n\n@media (max-width: 460px) {\n  .vp-wrapper {\n    flex-direction: column;\n\n    .vp-userdetails {\n      padding: 20px 0px 0px;\n    }\n\n    .mat-mdc-card-header {\n      max-width: 100%;\n    }\n  }\n\n  .example-container {\n    // overflow:scroll !important;\n    height: inherit !important;\n\n    .user-pro {\n      grid-template-columns: 1fr;\n      gap: 0;\n      padding: 0px 0px 0px 0px !important;\n\n      margin: 0;\n      width: 100%;\n\n      .item {\n        width: 100% !important;\n        margin: 0 !important;\n        border-radius: 0 !important;\n        padding: 0;\n      }\n\n      /* Thumbnail wrapper - full width, square edges */\n      .item > div:first-child {\n        border-radius: 0 !important;\n        margin-bottom: 12px !important;\n        width: 100%;\n      }\n\n      /* Images and videos - full width, square edges */\n      .item .img-display,\n      .item .video-display {\n        border-radius: 0 !important;\n        width: 100% !important;\n      }\n\n      /* Reduce spacing in card content on mobile */\n      .item > div:last-child {\n        padding: 0 12px 8px 12px;\n        gap: 4px;\n\n        p.lf13 {\n          margin: 0 !important;\n          line-height: 1.3;\n        }\n\n        p:not(.lf13):not(.with-icon p) {\n          margin: 0 !important;\n          line-height: 1.2;\n        }\n\n        .with-icon {\n          margin: 0 !important;\n\n          p {\n            line-height: 1.2;\n          }\n        }\n      }\n    }\n  }\n\n  .gridgroup-wrap .mat-badge {\n    font-size: 10px;\n  }\n}\n\n/*flow by id has 6 item in dt and user flow has 5*/\n.user-pro .ng-star-inserted:nth-child(6n + 6) .item {\n  margin-right: 20px;\n}\n\n/* Cards in tabs should have margin-top: 5px */\n.tabs-container .user-pro .item,\n.mat-tab-body-content .user-pro .item,\n.scroll.user-pro .item {\n  margin-top: 5px !important;\n}\n\n// .example-container::-webkit-scrollbar {\n//   width: 4px;\n//   height: 100px;\n//   // display: none;\n// }\n// .example-container::-webkit-scrollbar-track {\n//   -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n// }\n// .example-container::-webkit-scrollbar-thumb {\n//   background-color: #5ea1d8;\n//   outline: 1px solid #5ea1d8;\n// }\n\n.vp-wrapper {\n  .tagparent {\n    display: flex;\n    align-items: center;\n\n    h2 {\n      flex: 1;\n    }\n\n    span {\n      color: rgba(0, 0, 0, 0.54) !important;\n      font-size: 35px !important;\n\n      .material-icons {\n        font-size: 35px !important;\n      }\n    }\n  }\n\n  /* Mobile/tablet: ensure tagparent wraps properly */\n  @media (max-width: 992px) {\n    .tagparent {\n      flex-wrap: wrap;\n\n      .profile-title-row {\n        flex: 1 1 auto;\n        min-width: 0;\n      }\n\n      > span {\n        flex-shrink: 0;\n      }\n    }\n  }\n}\n\n.tagparent > div {\n  flex: 1;\n}\n\n.vp-wrapper .material-icons {\n  font-size: 24px;\n}\n\n// .main-panel {\n//   height: 100px;\n//   overflow-y: scroll;\n// }\n.flowbycat {\n  position: sticky;\n  top: 0px;\n}\n\n// .img-div-left{\n//   position: fixed;\n//   z-index: 999;\n//   height: 150px;\n//   width: 150px;\n//   overflow: visible;\n//   margin: auto;\n//   top: 0;\n//   left: 0;\n//   bottom: 0;\n//   right: 0;\n// }\n@media only screen and (max-width: 1024px) and (min-width: 993px) {\n  .vp-wrapper {\n    flex-direction: column;\n    padding: 2rem 1rem !important;\n  }\n\n  .vp-wrapper .vp-userdetails {\n    padding: 20px 0px 0px 0px !important;\n  }\n}\n\n.scroll .item .uni-wrapper .bundleIcon {\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px !important;\n  height: 25px !important;\n  max-width: 25px !important;\n  height: 25px !important;\n\n  img {\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n\n/* Bundle icon inside video-thumbnail (new card structure) */\n.scroll .item .video-thumbnail .bundleIcon {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px !important;\n  height: 25px !important;\n  max-width: 25px !important;\n\n  img {\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n\n.uni-wrapper {\n  display: flex;\n  width: 100%;\n  align-items: center;\n\n  P {\n    flex: 1;\n  }\n}\n\n.tabs-container {\n  display: flex;\n  overflow-x: auto;\n  white-space: nowrap;\n  /* Prevent tabs from wrapping onto multiple lines */\n  position: sticky;\n  top: 0; /* header offset handled by outer container */\n  z-index: 5;\n  background: #ffffff;\n  \n  .item {\n    margin-top: 5px;\n  }\n}\n\n/* Mobile search header — aligned with app header mobile search (search-box / app-search-input) */\n.mobile-search-header {\n  position: sticky;\n  top: 0;\n  z-index: 8;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-bottom: 1px solid #eee;\n\n  .profile-search-toggle {\n    flex-shrink: 0;\n    border: none;\n    background: transparent;\n    padding: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: #606060;\n    border-radius: 50%;\n    transition: color 0.2s, background-color 0.2s;\n\n    &:hover {\n      color: #000000;\n      background-color: transparent;\n    }\n\n    mat-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  .profile-mobile-search-box {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    align-items: center;\n    position: relative;\n    overflow: visible;\n  }\n\n  .profile-mobile-search-box .mobile-search-field {\n    position: relative;\n    display: flex;\n    align-items: center;\n    flex: 1;\n    min-width: 0;\n    overflow: visible;\n    gap: 4px;\n    height: 100%;\n  }\n\n  .profile-mobile-search-box .mobile-search-field .app-search-input {\n    flex: 1;\n    min-width: 120px;\n    padding: 8px 16px;\n    padding-right: 8px;\n    border: 1px solid #d0d0d0;\n    border-radius: 24px;\n    font-size: 16px;\n    background: #ffffff;\n    height: 32px;\n    box-sizing: border-box;\n    color: #000000;\n    outline: none;\n\n    &::placeholder {\n      color: #666666;\n    }\n  }\n\n  .profile-mobile-search-box\n    .mobile-search-field:focus-within\n    .app-search-input {\n    border-color: #1a73e8;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  }\n\n  .profile-mobile-search-box .mobile-search-field .cancel-icon-button,\n  .profile-mobile-search-box .mobile-search-field .search-icon-button {\n    flex-shrink: 0;\n    padding: 8px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #606060;\n    border-radius: 50%;\n    transition: color 0.2s, background-color 0.2s;\n\n    &:hover {\n      color: #000000;\n      background-color: transparent;\n    }\n  }\n\n  .profile-mobile-search-box .mobile-search-field .cancel-icon-button mat-icon,\n  .profile-mobile-search-box .mobile-search-field .search-icon-button mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n.foot-ico {\n  padding: 8px 0 10px 0;\n\n  ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    justify-content: space-around;\n    align-items: flex-start;\n  }\n\n  ul li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 4px;\n\n    span {\n      text-align: center;\n      display: block;\n      width: 100%;\n    }\n\n    .icon-text {\n      text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);\n      font-size: 12px;\n      color: gray;\n      display: block;\n      text-align: center;\n      font-family: \"Raleway\" !important;\n      margin-top: 2px;\n      line-height: 1.2;\n    }\n  }\n}\n\na.textcolor:hover {\n  text-decoration: underline;\n}\n.featured-section {\n  // padding: 1rem;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.section-title {\n  font-size: 1rem;\n  // font-weight: bold;\n  margin-bottom: 1rem;\n}\n\n.featured-scroll-container {\n  display: flex;\n  gap: 16px;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  padding-bottom: 8px;\n}\n\n.featured-card {\n  flex: 0 0 auto;\n  width: 140px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  text-decoration: none;\n  color: inherit;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  transition: box-shadow 0.3s ease;\n  scroll-snap-align: start;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n\n  img {\n    width: 100%;\n    height: 130px;\n    object-fit: cover;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n  }\n\n  .card-content {\n    padding: 12px 14px;\n\n    .card-title {\n      font-size: 14px;\n      font-weight: 600;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-bottom: 6px;\n    }\n\n    .card-description {\n      font-size: 13px;\n      color: #555;\n      height: 38px;\n      overflow: hidden;\n    }\n  }\n}\n\n/* Optional: Scrollbar styling for better UX */\n.featured-scroll-container::-webkit-scrollbar {\n  height: 6px;\n}\n.featured-scroll-container::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 4px;\n}\n\n.featured-scroll-container {\n  display: flex;\n  overflow-x: auto;\n  gap: 12px;\n  align-items: stretch;\n}\n\n/* Ensure only skeleton cards have zero inner margins */\n.user-pro {\n  .item.skeleton-item {\n    > div {\n      margin: 0 !important;\n    }\n  }\n}\n\n/* Card edge behaviors */\n.scroll .item {\n  transition: border-radius 0.2s ease, box-shadow 0.2s ease;\n  overflow: hidden;\n  margin-top: 5px;\n}\n\n@media (min-width: 993px) {\n  /* Desktop: show square edge on hover */\n  .scroll .item:hover {\n    border-radius: 0 !important;\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n  }\n  .scroll .item:hover .img-display,\n  .scroll .item:hover .video-display {\n    border-radius: 0 !important;\n  }\n}\n\n@media (max-width: 767px) {\n  /* Mobile: full-width square cards */\n  .example-container {\n    .user-pro {\n      .item {\n        width: 100% !important;\n        margin: 8px 0 !important;\n        border-radius: 0 !important;\n      }\n\n      img.img-display,\n      video.video-display {\n        width: 100% !important;\n        height: auto;\n        border-radius: 0 !important;\n      }\n    }\n  }\n\n  /* Mobile: maintain 16:9 aspect ratio matching search component */\n  .user-pro {\n    .item {\n      /* Thumbnail wrapper maintains 16:9 aspect ratio */\n      > div:first-child {\n        aspect-ratio: 16/9 !important;\n        border-radius: 0 !important;\n        width: 100% !important;\n      }\n\n      .img-display,\n      .video-display {\n        width: 100% !important;\n        height: 100% !important;\n        border-radius: 0 !important;\n        object-fit: cover !important;\n        aspect-ratio: 16/9 !important;\n      }\n    }\n  }\n\n  /* Override search-style thumbnail to match search component on mobile */\n  .video-thumbnail {\n    aspect-ratio: 16/9 !important;\n    border-radius: 0 !important;\n    width: 100% !important;\n  }\n  .thumbnail-image,\n  .thumbnail-video {\n    width: 100% !important;\n    height: 100% !important;\n    border-radius: 0 !important;\n    object-fit: cover !important;\n  }\n}\n\n/* Overlay price badge to match search page */\n.scroll .item .priceIcon-p,\n.user-pro .item .priceIcon-p {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 10;\n  background-color: rgba(33, 36, 39, 0.5);\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1;\n  padding: 6px 10px;\n  border-radius: 6px;\n  backdrop-filter: saturate(120%);\n  margin: 0;\n  border: none;\n\n  mat-label {\n    color: #ffffff !important;\n    font-size: 16px !important;\n  }\n}\n\n.featured-card {\n  flex: 0 0 auto;\n  width: 250px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  overflow: hidden;\n  text-decoration: none;\n  color: inherit;\n}\n\n.card-content {\n  padding: 10px;\n}\n\n.card-title {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.view-all-text {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  font-weight: 500;\n  color: #007bff;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.view-all-text:hover {\n  text-decoration: underline;\n}\n\n/* Skeleton Loader Styles for Profile Section */\n.skeleton-profile-card {\n  background: #fff !important;\n  border: 1px solid #ddd;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.skeleton-text {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  height: 16px;\n  margin: 6px 0;\n\n  &.skeleton-username {\n    height: 24px;\n    width: 150px;\n    margin-bottom: 10px;\n  }\n\n  &.skeleton-name {\n    height: 20px;\n    width: 200px;\n    margin-bottom: 8px;\n  }\n\n  &.skeleton-description {\n    height: 16px;\n    width: 100%;\n    margin-bottom: 6px;\n  }\n\n  &.skeleton-link {\n    height: 14px;\n    width: 120px;\n    margin-bottom: 4px;\n  }\n\n  &.skeleton-stat-number {\n    height: 24px;\n    width: 40px;\n    margin-bottom: 4px;\n  }\n\n  &.skeleton-stat-label {\n    height: 14px;\n    width: 60px;\n  }\n\n  &.skeleton-button {\n    height: 32px;\n    width: 120px;\n    margin: 8px 0;\n  }\n}\n\n.skeleton-avatar {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n\n  &.skeleton-large-avatar {\n    width: 60px;\n    height: 60px;\n  }\n}\n\n.skeleton-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n\n  &.skeleton-qr-icon {\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.skeleton-stats {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 20px;\n  padding: 15px 0;\n  border-top: 1px solid #e0e0e0;\n}\n\n.skeleton-stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.skeleton-button-wrap {\n  display: flex;\n  flex-direction: column;\n  margin-top: 20px;\n  gap: 10px;\n}\n\n/* Search-page-style skeleton card (used in view-profile grid) */\n.skeleton-card {\n  background-color: #f9f9f9;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.skeleton-thumbnail {\n  width: 100%;\n  height: 100%;\n  display: block;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n}\n\n/* Skeleton Loader Styles for Infinite Scroll */\n.skeleton-item {\n  background: #f9f9f9;\n  border: none;\n  border-radius: 12px;\n  padding: 0;\n  box-shadow: none;\n  margin-bottom: 20px;\n  overflow: hidden;\n}\n\n.skeleton-media {\n  width: 100%;\n  aspect-ratio: 16/9;\n  height: auto;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 12px;\n  margin-bottom: 12px;\n}\n\n.skeleton-text {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  height: 16px;\n  margin: 6px 0;\n\n  &.title {\n    height: 20px;\n    width: 80%;\n    margin-bottom: 8px;\n  }\n\n  &.subtitle {\n    height: 14px;\n    width: 60%;\n    margin-bottom: 10px;\n  }\n\n  &.username {\n    height: 14px;\n    width: 100px;\n  }\n\n  &.price {\n    height: 16px;\n    width: 60px;\n    margin-top: 8px;\n  }\n}\n\n.skeleton-info {\n  display: flex;\n  gap: 8px;\n  padding: 0;\n  align-items: center;\n}\n\n.skeleton-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  flex-shrink: 0;\n}\n\n.skeleton-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.skeleton-user {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.skeleton-title {\n  height: 14px;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  margin-bottom: 6px;\n  width: 72%;\n}\n\n.skeleton-channel {\n  height: 12px;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  margin-bottom: 4px;\n  width: 48%;\n}\n\n.skeleton-meta {\n  height: 11px;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  width: 34%;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* Responsive Design for Skeleton */\n@media (max-width: 768px) {\n  .skeleton-item {\n    padding: 0;\n    margin-bottom: 15px;\n  }\n\n  .skeleton-media {\n    aspect-ratio: 16/9;\n    height: auto;\n    border-radius: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .skeleton-item {\n    padding: 0;\n    margin-bottom: 10px;\n  }\n\n  .skeleton-media {\n    aspect-ratio: 16/9;\n    height: auto;\n    border-radius: 0;\n  }\n\n  .skeleton-text {\n    height: 14px;\n\n    &.title {\n      height: 18px;\n    }\n\n    &.subtitle {\n      height: 12px;\n    }\n  }\n}\n\n/* Enforce circular avatar sizing for profile hero */\n.profile-hero .example-header-image img {\n  width: 120px !important;\n  height: 120px !important;\n  object-fit: cover !important;\n  border-radius: 50% !important;\n}\n\n@media (min-width: 993px) {\n  .profile-hero .example-header-image img {\n    width: 150px !important;\n    height: 150px !important;\n  }\n}\n\n/* Ensure mat card avatar inside profile hero is square & circular */\n.vp-wrapper .mat-mdc-card-header .mat-mdc-card-avatar img {\n  width: 150px !important;\n  height: 150px !important;\n  object-fit: cover !important;\n  border-radius: 50% !important;\n}\n\n/* Safety for very small devices */\n@media (max-width: 360px) {\n  .profile-hero .example-header-image img,\n  .vp-wrapper .mat-mdc-card-header .mat-mdc-card-avatar img {\n    width: 40vw !important;\n    height: 40vw !important;\n  }\n}\n\n/* Card avatars in flow lists - match search page dimensions */\n.video-avatar {\n  width: 24px !important;\n  height: 24px !important;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.video-avatar .avatar-image {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover !important;\n  border-radius: 50% !important;\n  display: block !important;\n}\n\n/* Fallback where avatar is rendered via mat-card-avatar attribute */\n.with-icon img[mat-card-avatar] {\n  width: 36px !important;\n  height: 36px !important;\n  object-fit: cover !important;\n  border-radius: 50% !important;\n}\n\n/* Desktop/default: search-like thumbnail styling */\n.video-thumbnail {\n  position: relative;\n  width: 100% !important;\n  aspect-ratio: 16/9 !important;\n  background-color: #f5f5f5 !important;\n  border-radius: 12px !important;\n  overflow: hidden !important;\n  margin-bottom: 12px !important;\n  /* Preserve original card dimensions - do not change */\n  min-height: 0 !important;\n  max-height: none !important;\n}\n\n.video-duration {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  z-index: 2;\n\n  .duration-icon {\n    font-size: 13px;\n    width: 13px;\n    height: 13px;\n    line-height: 13px;\n  }\n}\n.thumbnail-image,\n.thumbnail-video {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover !important;\n  display: block !important;\n}\n\n.sponsored-card-badge {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  pointer-events: none;\n\n  mat-icon {\n    font-size: 13px;\n    width: 13px;\n    height: 13px;\n    line-height: 13px;\n  }\n}\n\n/* Legacy classes should behave the same as search cards */\n.user-pro .item .img-display,\n.user-pro .item .video-display {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover !important;\n  background-color: #f5f5f5 !important;\n  border-radius: 12px !important;\n}\n\n/* Remove horizontal padding around tabs/content area */\n.container-fluid.tabs-container,\n.tabs-container.container-fluid {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  margin-bottom: 24px !important; /* Add space after tabs */\n}\n.tabs-container .mat-mdc-tab-body-wrapper {\n  padding: 0 !important;\n}\n\n/* Center the Builds empty-state message in the viewport while reusing noFlows */\n.builds-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: 60vh;\n  margin-top: 0 !important;\n}\n\n/* Make sure the Builds empty-state spans full grid width and is centered in the grid */\n.scroll.user-pro .builds-empty {\n  grid-column: 1 / -1;\n  width: 100%;\n  justify-self: center;\n}\n\n/* Ensure search-like 16:9 thumbnails on mobile with full width */\n@media (max-width: 767px) {\n  /* Mobile: full-width with square edges matching search component */\n  .user-pro .item,\n  .user-pro .item .video-thumbnail,\n  .video-thumbnail {\n    border-radius: 0 !important;\n  }\n\n  /* Maintain 16:9 aspect ratio on mobile matching search component */\n  .video-thumbnail {\n    aspect-ratio: 16/9 !important;\n    margin-bottom: 12px !important;\n    width: 100% !important;\n  }\n\n  /* Ensure wrapper containers maintain aspect ratio */\n  .user-pro .item > div:first-child {\n    aspect-ratio: 16/9 !important;\n    width: 100% !important;\n    border-radius: 0 !important;\n  }\n\n  .thumbnail-image,\n  .thumbnail-video,\n  .user-pro .item .img-display,\n  .user-pro .item .video-display {\n    width: 100% !important;\n    height: 100% !important;\n    object-fit: cover !important;\n    border-radius: 0 !important;\n  }\n}\n\n/* Fallback for browsers that do not support aspect-ratio */\n@supports not (aspect-ratio: 1 / 1) {\n  .video-thumbnail {\n    position: relative;\n    width: 100% !important;\n    height: 0 !important;\n    padding-top: 56.25% !important; /* 16:9 */\n    overflow: hidden !important;\n  }\n  .thumbnail-image,\n  .thumbnail-video {\n    position: absolute !important;\n    top: 0;\n    left: 0;\n    width: 100% !important;\n    height: 100% !important;\n    object-fit: cover !important;\n    display: block !important;\n  }\n}\n\n/* Align video info like search page */\n.video-info {\n  display: flex;\n  gap: 0; /* no gap since avatar is now inside video-details */\n}\n\n/* Mobile-only tweak: slight left margin for video info row - match search page */\n@media (max-width: 768px) {\n  .video-info {\n    margin-left: 5px; /* Match search page mobile */\n  }\n}\n@media (max-width: 768px) {\n  .video-details {\n    margin-left: 5px !important; /* Match search page mobile */\n  }\n}\n\n/* Video avatar styles - ensure visibility */\n.video-avatar {\n  width: 24px !important;\n  height: 24px !important;\n  border-radius: 50% !important;\n  overflow: hidden !important;\n  flex-shrink: 0 !important;\n  cursor: pointer !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.avatar-image {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover !important;\n  display: block !important;\n  border-radius: 50% !important;\n}\n\n.avatar-icon {\n  width: 100% !important;\n  height: 100% !important;\n  font-size: 24px !important;\n  color: #212427 !important;\n  display: block !important;\n}\n\n.video-details {\n  flex: 1;\n  min-width: 0;\n  display: flex; /* stacked layout */\n  flex-direction: column;\n  gap: 0; /* no spacing between rows */\n  margin: 0;\n  padding: 0;\n}\n\n.video-title-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px; /* proper spacing between title and menu */\n  margin: 0; /* no extra space below title */\n  margin-bottom: 0 !important;\n  padding: 0;\n  justify-content: space-between;\n}\n\n.video-title {\n  font-size: 16px !important;\n  font-weight: bold !important; /* match requested bold weight for profile cards */\n  color: #000000 !important;\n  margin: 0 !important;\n  margin-bottom: 0px !important;\n  line-height: 1.3 !important; /* proper line height for readability */\n  display: -webkit-box !important;\n  -webkit-line-clamp: 2 !important; /* allow 2 lines to show full title */\n  line-clamp: 2 !important;\n  -webkit-box-orient: vertical !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  cursor: pointer !important;\n  flex: 1 !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  padding-right: 4px !important; /* space for menu button */\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n  white-space: normal !important; /* allow wrapping */\n  hyphens: auto !important; /* allow hyphenation for long words */\n}\n\n.video-title:hover {\n  color: #666666;\n}\n\n.channel-meta-row {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  cursor: pointer !important;\n  margin: 0 !important;\n  margin-top: -2px !important; /* negative margin to eliminate gap */\n  padding: 0 !important;\n  flex-wrap: nowrap !important;\n  line-height: 1 !important; /* minimal line height */\n  justify-content: space-between !important;\n  position: relative !important;\n  width: 100% !important;\n}\n\n/* Group avatar and username together */\n.channel-info {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  cursor: pointer !important;\n  margin: 0 !important;\n  flex-shrink: 0 !important;\n}\n\n.channel-meta-row > *:not(.video-views) {\n  flex-shrink: 0 !important;\n}\n\n/* Ensure avatar and username stay together on same line */\n.channel-info .video-avatar {\n  flex-shrink: 0 !important;\n  margin-right: 0 !important;\n}\n\n.channel-info .channel-name {\n  font-size: 13px !important;\n  color: #606060 !important;\n  margin: 0px !important;\n  margin-top: 0px !important;\n  margin-bottom: 0px !important;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  line-height: 1.3 !important;\n  cursor: pointer !important;\n  white-space: nowrap !important;\n  flex-shrink: 0 !important;\n  display: inline-block !important;\n}\n\n.channel-name:hover {\n  color: #000000;\n}\n\n/* YouTube-style collab: overlapping avatars + \"name and @coauthor\" */\n.avatar-stack {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n\n  .video-avatar {\n    position: relative;\n    z-index: 1;\n  }\n\n  .collab-avatar-overlap {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-left: -7px;\n    border: 2px solid #fff;\n    z-index: 2;\n    position: relative;\n    flex-shrink: 0;\n  }\n\n  .collab-avatar-extra {\n    position: relative;\n    width: 20px;\n    height: 20px;\n    margin-left: -7px;\n    z-index: 3;\n    flex-shrink: 0;\n    cursor: pointer;\n\n    .collab-extra-img {\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      object-fit: cover;\n      border: 2px solid #fff;\n      display: block;\n    }\n\n    .collab-extra-badge {\n      position: absolute;\n      bottom: -3px;\n      right: -4px;\n      background: #3b82f6;\n      color: #fff;\n      font-size: 7px;\n      font-weight: 700;\n      border-radius: 8px;\n      padding: 1px 3px;\n      line-height: 1.2;\n      white-space: nowrap;\n    }\n  }\n\n  .collab-avatar-overlap-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    margin-left: -7px;\n    color: #bbb;\n    z-index: 2;\n    position: relative;\n    flex-shrink: 0;\n    background: #f0f0f0;\n    border-radius: 50%;\n    border: 2px solid #fff;\n    line-height: 20px;\n  }\n}\n\n.collab-sep {\n  color: #888;\n  font-weight: 400;\n  font-size: 11px;\n}\n\n.collab-coname {\n  font-weight: 500;\n  cursor: pointer;\n  &:hover { text-decoration: underline; }\n}\n\n.collab-extra-count-text {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n  &:hover { text-decoration: underline; }\n}\n\n/* Wrapper that provides positioning context for the popup */\n.avatar-stack-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n/* Cursor hint when avatar stack is clickable */\n.collab-stack-clickable {\n  cursor: pointer;\n}\n\n/* Collaborators centred popup backdrop */\n.collab-popup-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 499;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n/* Collaborators centred popup */\n.collab-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 500;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22), 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px 16px 14px;\n  width: 300px;\n\n  .collab-popup-title {\n    font-size: 11px;\n    font-weight: 700;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #f3f4f6;\n    margin-bottom: 10px;\n    text-align: center;\n  }\n\n  .collab-popup-card {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 10px 10px;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 0.15s;\n\n    &:hover {\n      background: #f5f7fa;\n    }\n  }\n\n  .collab-popup-avatar-wrap {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n    border: 2px solid #e5e7eb;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f3f4f6;\n  }\n\n  .collab-popup-pic {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n  }\n\n  .collab-popup-icon {\n    font-size: 34px;\n    width: 34px;\n    height: 34px;\n    color: #9ca3af;\n    line-height: 1;\n  }\n\n  .collab-popup-uname {\n    font-size: 13px;\n    font-weight: 600;\n    color: #1a1a2e;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n  }\n}\n\n.video-views {\n  margin: 0 !important;\n  font-size: 11px !important;\n  font-weight: 600 !important;\n  color: #1d67a3 !important;\n  background-color: #e3f2fd !important;\n  padding: 3px 8px !important;\n  border-radius: 4px !important;\n  white-space: nowrap !important;\n  display: inline-block !important;\n  line-height: 1.2 !important;\n  letter-spacing: 0.3px !important;\n  align-self: center !important;\n  margin-left: auto !important;\n  flex-shrink: 0 !important;\n}\n\n// Review Card Styles for Profile Page\n.review-card-profile {\n  padding: 24px;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #f1f5f9;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin-bottom: 16px;\n  transition: all 0.2s;\n\n  &:hover {\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n\n  .review-header-profile {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom: 16px;\n\n    .reviewer-info-profile {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n\n      .reviewer-avatar-profile {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-weight: 700;\n        font-size: 16px;\n        color: #4f46e5;\n        flex-shrink: 0;\n      }\n\n      .reviewer-details-profile {\n        h4 {\n          font-weight: 700;\n          font-size: 16px;\n          color: #0f172a;\n          margin: 0 0 4px 0;\n        }\n\n        .review-rating-profile {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n\n          .review-star-icon {\n            font-size: 14px;\n            width: 14px;\n            height: 14px;\n            color: #cbd5e1;\n\n            &.filled-star {\n              color: #f59e0b;\n            }\n          }\n\n          .review-date-profile {\n            font-size: 12px;\n            color: #94a3b8;\n          }\n        }\n      }\n    }\n  }\n\n  .review-title-profile {\n    font-size: 18px;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0 0 8px 0;\n  }\n\n  .review-text-profile {\n    color: #475569;\n    line-height: 1.6;\n    margin: 0 0 12px 0;\n  }\n\n  .review-flow-link {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px solid #f1f5f9;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      color: #64748b;\n    }\n\n    a {\n      color: #f59e0b;\n      font-weight: 600;\n      font-size: 14px;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n.skeleton-review-card {\n  padding: 24px;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #f1f5f9;\n  margin-bottom: 16px;\n\n  .skeleton-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: loading 1.5s infinite;\n    margin-bottom: 12px;\n  }\n\n  .skeleton-title {\n    height: 20px;\n    width: 60%;\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: loading 1.5s infinite;\n    border-radius: 4px;\n    margin-bottom: 8px;\n  }\n\n  .skeleton-content {\n    height: 16px;\n    width: 100%;\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: loading 1.5s infinite;\n    border-radius: 4px;\n    margin-bottom: 8px;\n\n    &:last-child {\n      width: 80%;\n    }\n  }\n}\n\n@keyframes loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* Dark mode overrides for user/view profile pages */\n:host-context(body.theme-dark) {\n  .content-status-badge {\n    background: rgba(255, 255, 255, 0.08);\n    color: #d0d5dd;\n\n    &[data-state=\"in-review\"] {\n      background: rgba(181, 71, 8, 0.2);\n      color: #fdba74;\n    }\n\n    &[data-state=\"rejected\"] {\n      background: rgba(240, 68, 56, 0.16);\n      color: #fda29b;\n    }\n\n    &[data-state=\"approved\"] {\n      background: rgba(18, 183, 106, 0.16);\n      color: #75e0a7;\n    }\n\n    &[data-state=\"pack\"] {\n      background: rgba(68, 76, 231, 0.2);\n      color: #a4bcfd;\n    }\n  }\n\n  .example-container,\n  mat-sidenav-content.example-container,\n  .gridgroup-wrap,\n  .vp-wrapper,\n  .tabs-container,\n  .featured-section {\n    background: #0a0c10 !important;\n    color: #ffffff !important;\n  }\n\n  .vp-wrapper,\n  .skeleton-profile-card,\n  .featured-card,\n  .review-card-profile,\n  .skeleton-review-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    color: #ffffff !important;\n  }\n\n  /* Search-style skeleton card in dark mode */\n  .skeleton-card {\n    background-color: #1e293b !important;\n    border: 1px solid rgba(148, 163, 184, 0.15) !important;\n  }\n\n  .skeleton-card .skeleton-thumbnail,\n  .skeleton-card .skeleton-title,\n  .skeleton-card .skeleton-channel,\n  .skeleton-card .skeleton-meta,\n  .skeleton-card .video-avatar .skeleton-avatar {\n    background: linear-gradient(\n      90deg,\n      #334155 25%,\n      #64748b 50%,\n      #334155 75%\n    ) !important;\n    background-size: 200% 100% !important;\n  }\n\n  /* Grid skeleton cards: visible card shape against dark page */\n  .skeleton-item {\n    background: #1e293b !important;\n    border: 1px solid rgba(148, 163, 184, 0.15) !important;\n    color: #ffffff !important;\n  }\n\n  /* Grid skeleton shimmer — high enough contrast to be clearly visible */\n  .skeleton-item .skeleton-media,\n  .skeleton-item .skeleton-text,\n  .skeleton-item .skeleton-avatar,\n  .skeleton-item .skeleton-title,\n  .skeleton-item .skeleton-channel,\n  .skeleton-item .skeleton-meta {\n    background: linear-gradient(\n      90deg,\n      #334155 25%,\n      #64748b 50%,\n      #334155 75%\n    ) !important;\n    background-size: 200% 100% !important;\n  }\n\n  /* Profile header skeleton + tab card skeletons — same visible shimmer */\n  .skeleton-profile-card .skeleton-text,\n  .skeleton-profile-card .skeleton-avatar,\n  .skeleton-profile-card .skeleton-icon,\n  .skeleton-item .skeleton-info .skeleton-avatar,\n  .skeleton-item .skeleton-details .skeleton-title,\n  .skeleton-item .skeleton-details .skeleton-channel,\n  .skeleton-item .skeleton-details .skeleton-meta,\n  .skeleton-item .skeleton-text.title,\n  .skeleton-item .skeleton-text.subtitle,\n  .skeleton-item .skeleton-text.username,\n  .skeleton-item .skeleton-user .skeleton-avatar,\n  .skeleton-item .skeleton-user .skeleton-text {\n    background: linear-gradient(\n      90deg,\n      #334155 25%,\n      #64748b 50%,\n      #334155 75%\n    ) !important;\n    background-size: 200% 100% !important;\n  }\n\n  /* Profile card header shimmer */\n  .skeleton-profile-card .skeleton-text,\n  .skeleton-profile-card .skeleton-avatar,\n  .skeleton-profile-card .skeleton-icon {\n    background: linear-gradient(\n      90deg,\n      #1f2937 25%,\n      #4b5563 50%,\n      #1f2937 75%\n    ) !important;\n    background-size: 200% 100% !important;\n  }\n\n  .skeleton-profile-card {\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .skeleton-stats {\n    border-top-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  /* Review card inner shimmer elements in dark mode */\n  .skeleton-review-card .skeleton-avatar,\n  .skeleton-review-card .skeleton-title,\n  .skeleton-review-card .skeleton-content {\n    background: linear-gradient(\n      90deg,\n      #1f2937 25%,\n      #4b5563 50%,\n      #1f2937 75%\n    ) !important;\n    background-size: 200% 100% !important;\n  }\n\n  /* Match search .video-card: no full-bleed tile behind title/meta — only thumb uses #111827 */\n  .user-pro .item:not(.skeleton-item) {\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n    color: #f3f4f6 !important;\n  }\n\n  .userico {\n    background: #0a0c10 !important;\n  }\n\n  .gridgroup-wrap .mat-mdc-tab-header,\n  .gridgroup-wrap .mat-mdc-tab-group .mat-mdc-tab-header,\n  .tabs-container {\n    background: #111827 !important;\n    border-bottom: 1px solid rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .vp-wrapper .vp-userdetails,\n  .vp-wrapper .vp-userdetails span,\n  .video-title,\n  .profile-title-row h2,\n  .profile-stats .stat .stat-number,\n  .profile-stat-bar .profile-stat-item .value,\n  .section-title,\n  .card-title,\n  .review-title-profile,\n  .reviewer-details-profile h4,\n  .review-text-profile,\n  .noFlows h4,\n  .noFlows p {\n    color: #ffffff !important;\n  }\n\n  .channel-name,\n  .video-meta,\n  .video-date,\n  .video-views,\n  .profile-stats .stat .stat-label,\n  .profile-stat-bar .profile-stat-item .label,\n  .view-all-text,\n  .card-description,\n  .review-date-profile {\n    color: #cbd5e1 !important;\n  }\n\n  .video-thumbnail,\n  .user-pro .item > div:first-child {\n    background: #111827 !important; /* same as search .video-thumbnail */\n  }\n\n  .user-pro .item .img-display,\n  .user-pro .item .video-display {\n    background-color: #111827 !important;\n  }\n\n  .user-pro .item p.lf13 {\n    color: #f3f4f6 !important; /* search .video-title */\n  }\n\n  .user-pro .item .with-icon p {\n    color: #9ca3af !important; /* search .channel-name */\n  }\n\n  .user-pro .item p:not(.lf13):not(.with-icon p) {\n    color: #9ca3af !important;\n  }\n\n  /* View-profile / own-profile grids use same classes as search */\n  .user-pro .video-title {\n    color: #f3f4f6 !important;\n  }\n\n  .user-pro .video-title:hover {\n    color: #d1d5db !important; /* search */\n  }\n\n  .user-pro .channel-name,\n  .user-pro .channel-info .channel-name {\n    color: #9ca3af !important;\n  }\n\n  .user-pro .channel-name:hover {\n    color: #e5e7eb !important; /* search .channel-name:hover */\n  }\n\n  .avatar-stack {\n    .collab-avatar-overlap,\n    .collab-avatar-overlap-icon {\n      border-color: #1f2937;\n      background: #374151;\n    }\n    .collab-avatar-overlap-icon { color: #6b7280; }\n    .collab-avatar-extra {\n      border-color: #1f2937;\n      background: #374151;\n      color: #d1d5db;\n    }\n  }\n\n  .collab-sep { color: #6b7280; }\n  .collab-coname { color: #9ca3af; }\n\n  .user-pro .video-views,\n  .user-pro .video-time {\n    background-color: rgba(94, 161, 216, 0.2) !important;\n    color: #93c5fd !important;\n  }\n\n  @media (min-width: 993px) {\n    .example-container .vp-wrapper {\n      border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n    }\n  }\n\n  .mobile-search-header {\n    background: transparent !important;\n    border-color: transparent !important;\n  }\n\n  .mobile-search-header .profile-mobile-search-box .mobile-search-field .app-search-input {\n    background: #111827 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .mobile-search-header .profile-search-toggle,\n  .mobile-search-header .profile-mobile-search-box .mobile-search-field .cancel-icon-button,\n  .mobile-search-header .profile-mobile-search-box .mobile-search-field .search-icon-button {\n    color: #cbd5e1 !important;\n  }\n\n  .mobile-search-header .profile-search-toggle:hover,\n  .mobile-search-header .profile-mobile-search-box .mobile-search-field .cancel-icon-button:hover,\n  .mobile-search-header .profile-mobile-search-box .mobile-search-field .search-icon-button:hover {\n    background: #273449 !important;\n    color: #ffffff !important;\n  }\n\n  .textcolor,\n  .textcolor:hover,\n  .profile-stat-bar .profile-stat-item .label,\n  .profile-stat-bar .profile-stat-item .value {\n    color: #ffffff !important;\n  }\n\n  .textcolor {\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  /* Collaborators popup — dark mode */\n  .collab-popup {\n    background: #1f2937;\n    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.6), 0 2px 10px rgba(0, 0, 0, 0.4);\n\n    .collab-popup-title {\n      color: #64748b;\n      border-bottom-color: rgba(148, 163, 184, 0.15);\n    }\n\n    .collab-popup-card:hover {\n      background: #374151;\n    }\n\n    .collab-popup-avatar-wrap {\n      border-color: #374151;\n      background: #111827;\n    }\n\n    .collab-popup-icon {\n      color: #6b7280;\n    }\n\n    .collab-popup-uname {\n      color: #e2e8f0;\n    }\n  }\n}\n\n/* Membership (Applications / Teams) cards reuse guide card layout;\n   cover uses a default app/team icon instead of a photo. */\n.membership-thumb {\n  background: #eef5fb !important;\n}\n\n.membership-thumb--app {\n  background: linear-gradient(145deg, #6bb0e0 0%, #4a8fc4 55%, #3576a8 100%) !important;\n}\n\n.membership-thumb--team {\n  background: linear-gradient(145deg, #7bc0a8 0%, #4f9e86 55%, #3a7d68 100%) !important;\n}\n\n.membership-cover-fallback {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 0;\n}\n\n.membership-cover-icon {\n  font-size: 56px !important;\n  width: 56px !important;\n  height: 56px !important;\n  line-height: 56px !important;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.scroll.user-pro .item.active {\n  outline: 2px solid #5ea1d8;\n  outline-offset: 2px;\n}\n\n.scroll.user-pro .item.active .video-thumbnail {\n  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.35);\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
